/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as WorkItemsRouteImport } from './routes/work-items'
import { Route as WidgetRouteImport } from './routes/widget'
import { Route as SettingsRouteImport } from './routes/settings'
import { Route as QuotesRouteImport } from './routes/quotes'
import { Route as ProductsRouteImport } from './routes/products'
import { Route as PricingRouteImport } from './routes/pricing'
import { Route as PortalsRouteImport } from './routes/portals'
import { Route as PartiesRouteImport } from './routes/parties'
import { Route as OrdersRouteImport } from './routes/orders'
import { Route as OnboardingRouteImport } from './routes/onboarding'
import { Route as NotificationsRouteImport } from './routes/notifications'
import { Route as ManufacturingRouteImport } from './routes/manufacturing'
import { Route as LoginRouteImport } from './routes/login'
import { Route as DocsRouteImport } from './routes/docs'
import { Route as DiagnosticsRouteImport } from './routes/diagnostics'
import { Route as DeviceRouteImport } from './routes/device'
import { Route as CommerceRouteImport } from './routes/commerce'
import { Route as CatalogRouteImport } from './routes/catalog'
import { Route as BackgroundJobsRouteImport } from './routes/background-jobs'
import { Route as AssistantRouteImport } from './routes/assistant'
import { Route as AdvisorRouteImport } from './routes/advisor'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as ActivityRouteImport } from './routes/activity'
import { Route as AccountingRouteImport } from './routes/accounting'
import { Route as IndexRouteImport } from './routes/index'
import { Route as WorkItemsIndexRouteImport } from './routes/work-items.index'
import { Route as SettingsIndexRouteImport } from './routes/settings.index'
import { Route as PortalsIndexRouteImport } from './routes/portals.index'
import { Route as PartiesIndexRouteImport } from './routes/parties.index'
import { Route as ManufacturingIndexRouteImport } from './routes/manufacturing.index'
import { Route as DocsIndexRouteImport } from './routes/docs.index'
import { Route as DiagnosticsIndexRouteImport } from './routes/diagnostics.index'
import { Route as CommerceIndexRouteImport } from './routes/commerce.index'
import { Route as CatalogIndexRouteImport } from './routes/catalog.index'
import { Route as BackgroundJobsIndexRouteImport } from './routes/background-jobs.index'
import { Route as AssistantIndexRouteImport } from './routes/assistant.index'
import { Route as AdvisorIndexRouteImport } from './routes/advisor.index'
import { Route as AdminIndexRouteImport } from './routes/admin.index'
import { Route as AccountingIndexRouteImport } from './routes/accounting.index'
import { Route as WorkItemsIdRouteImport } from './routes/work-items.$id'
import { Route as SettingsWorkItemsRouteImport } from './routes/settings.work-items'
import { Route as SettingsWebhooksRouteImport } from './routes/settings.webhooks'
import { Route as SettingsTokensRouteImport } from './routes/settings.tokens'
import { Route as SettingsTeamEmailRouteImport } from './routes/settings.team-email'
import { Route as SettingsTagsRouteImport } from './routes/settings.tags'
import { Route as SettingsSuppliersRouteImport } from './routes/settings.suppliers'
import { Route as SettingsSubscriptionRouteImport } from './routes/settings.subscription'
import { Route as SettingsServiceAccountsRouteImport } from './routes/settings.service-accounts'
import { Route as SettingsRolesRouteImport } from './routes/settings.roles'
import { Route as SettingsProfileRouteImport } from './routes/settings.profile'
import { Route as SettingsPluginsRouteImport } from './routes/settings.plugins'
import { Route as SettingsOrganizationRouteImport } from './routes/settings.organization'
import { Route as SettingsNotificationsRouteImport } from './routes/settings.notifications'
import { Route as SettingsMetalRouteImport } from './routes/settings.metal'
import { Route as SettingsMembersRouteImport } from './routes/settings.members'
import { Route as SettingsKnowledgeRouteImport } from './routes/settings.knowledge'
import { Route as SettingsIntegrationsRouteImport } from './routes/settings.integrations'
import { Route as SettingsGeneralRouteImport } from './routes/settings.general'
import { Route as SettingsExportTemplatesRouteImport } from './routes/settings.export-templates'
import { Route as SettingsEvalDatasetsRouteImport } from './routes/settings.eval-datasets'
import { Route as SettingsDiagramRouteImport } from './routes/settings.diagram'
import { Route as SettingsComplianceRouteImport } from './routes/settings.compliance'
import { Route as SettingsCodeTemplatesRouteImport } from './routes/settings.code-templates'
import { Route as SettingsChannelsRouteImport } from './routes/settings.channels'
import { Route as SettingsCatalogRouteImport } from './routes/settings.catalog'
import { Route as SettingsAppearanceRouteImport } from './routes/settings.appearance'
import { Route as SettingsAgentProfilesRouteImport } from './routes/settings.agent-profiles'
import { Route as PortalsIdRouteImport } from './routes/portals.$id'
import { Route as PartiesIdRouteImport } from './routes/parties.$id'
import { Route as ManufacturingSopRouteImport } from './routes/manufacturing.sop'
import { Route as ManufacturingProductionRouteImport } from './routes/manufacturing.production'
import { Route as ManufacturingExceptionsRouteImport } from './routes/manufacturing.exceptions'
import { Route as ManufacturingBoardRouteImport } from './routes/manufacturing.board'
import { Route as ManufacturingActionsRouteImport } from './routes/manufacturing.actions'
import { Route as KnowledgeDocIdRouteImport } from './routes/knowledge-doc.$id'
import { Route as InviteTokenRouteImport } from './routes/invite.$token'
import { Route as DocsPortalRouteImport } from './routes/docs.portal'
import { Route as DocsPluginsRouteImport } from './routes/docs.plugins'
import { Route as DiagnosticsStorageRouteImport } from './routes/diagnostics.storage'
import { Route as DiagnosticsSessionsRouteImport } from './routes/diagnostics.sessions'
import { Route as DiagnosticsPoliciesRouteImport } from './routes/diagnostics.policies'
import { Route as DiagnosticsLiveRouteImport } from './routes/diagnostics.live'
import { Route as DiagnosticsExportsRouteImport } from './routes/diagnostics.exports'
import { Route as DiagnosticsDevicesRouteImport } from './routes/diagnostics.devices'
import { Route as DiagnosticsAnalyticsRouteImport } from './routes/diagnostics.analytics'
import { Route as DiagnosticsActivityRouteImport } from './routes/diagnostics.activity'
import { Route as CommerceSubscriptionsRouteImport } from './routes/commerce.subscriptions'
import { Route as CommerceShipmentsRouteImport } from './routes/commerce.shipments'
import { Route as CommerceReturnsRouteImport } from './routes/commerce.returns'
import { Route as CommerceQuotesRouteImport } from './routes/commerce.quotes'
import { Route as CommercePromotionsRouteImport } from './routes/commerce.promotions'
import { Route as CommercePricingRouteImport } from './routes/commerce.pricing'
import { Route as CommercePricelistsRouteImport } from './routes/commerce.pricelists'
import { Route as CommercePortalsRouteImport } from './routes/commerce.portals'
import { Route as CommercePaymentsRouteImport } from './routes/commerce.payments'
import { Route as CommerceOrdersRouteImport } from './routes/commerce.orders'
import { Route as CommerceDeliveryRouteImport } from './routes/commerce.delivery'
import { Route as CommerceAnalyticsRouteImport } from './routes/commerce.analytics'
import { Route as CatalogProductsRouteImport } from './routes/catalog.products'
import { Route as CatalogCategoriesRouteImport } from './routes/catalog.categories'
import { Route as BackgroundJobsIdRouteImport } from './routes/background-jobs.$id'
import { Route as AuthMcpCallbackRouteImport } from './routes/auth/mcp-callback'
import { Route as AuthCallbackRouteImport } from './routes/auth/callback'
import { Route as AssistantMemoryRouteImport } from './routes/assistant.memory'
import { Route as AssistantThreadIdRouteImport } from './routes/assistant.$threadId'
import { Route as AdvisorIdRouteImport } from './routes/advisor.$id'
import { Route as AdminUsersRouteImport } from './routes/admin.users'
import { Route as AdminFeaturesRouteImport } from './routes/admin.features'
import { Route as AdminEvalRouteImport } from './routes/admin.eval'
import { Route as AdminDiagramRouteImport } from './routes/admin.diagram'
import { Route as AdminBillingRouteImport } from './routes/admin.billing'
import { Route as AdminAuditRouteImport } from './routes/admin.audit'
import { Route as AccountingStatementsRouteImport } from './routes/accounting.statements'
import { Route as AccountingSchemasRouteImport } from './routes/accounting.schemas'
import { Route as AccountingRecurringRouteImport } from './routes/accounting.recurring'
import { Route as AccountingReceivablesRouteImport } from './routes/accounting.receivables'
import { Route as AccountingQualityCheckRouteImport } from './routes/accounting.quality-check'
import { Route as AccountingPayablesRouteImport } from './routes/accounting.payables'
import { Route as AccountingOperationsRouteImport } from './routes/accounting.operations'
import { Route as AccountingCrosstabRouteImport } from './routes/accounting.crosstab'
import { Route as AccountingCounterpartyReconRouteImport } from './routes/accounting.counterparty-recon'
import { Route as AccountingConsolidationRouteImport } from './routes/accounting.consolidation'
import { Route as AccountingCloseRouteImport } from './routes/accounting.close'
import { Route as AccountingBudgetRouteImport } from './routes/accounting.budget'
import { Route as AccountingBankRouteImport } from './routes/accounting.bank'
import { Route as AccountingAssetsRouteImport } from './routes/accounting.assets'
import { Route as AccountingAnalysisRouteImport } from './routes/accounting.analysis'
import { Route as AccountingAccountsRouteImport } from './routes/accounting.accounts'
import { Route as SettingsSubscriptionIndexRouteImport } from './routes/settings.subscription.index'
import { Route as SettingsPluginsIndexRouteImport } from './routes/settings.plugins.index'
import { Route as DocsPortalIndexRouteImport } from './routes/docs.portal.index'
import { Route as DocsPluginsIndexRouteImport } from './routes/docs.plugins.index'
import { Route as DocsPhase1IndexRouteImport } from './routes/docs.phase1.index'
import { Route as CommerceShipmentsIndexRouteImport } from './routes/commerce.shipments.index'
import { Route as CommerceReturnsIndexRouteImport } from './routes/commerce.returns.index'
import { Route as CommerceQuotesIndexRouteImport } from './routes/commerce.quotes.index'
import { Route as CommerceOrdersIndexRouteImport } from './routes/commerce.orders.index'
import { Route as CatalogProductsIndexRouteImport } from './routes/catalog.products.index'
import { Route as AdminWorkspacesIndexRouteImport } from './routes/admin.workspaces.index'
import { Route as AdminFeaturesIndexRouteImport } from './routes/admin.features.index'
import { Route as AdminEvalIndexRouteImport } from './routes/admin.eval.index'
import { Route as AccountingJournalIndexRouteImport } from './routes/accounting.journal.index'
import { Route as SettingsSubscriptionBillingRouteImport } from './routes/settings.subscription.billing'
import { Route as SettingsPluginsMarketplaceRouteImport } from './routes/settings.plugins.marketplace'
import { Route as SettingsPluginsDeveloperRouteImport } from './routes/settings.plugins.developer'
import { Route as SettingsPluginsPluginIdRouteImport } from './routes/settings.plugins.$pluginId'
import { Route as SettingsExportTemplatesIdRouteImport } from './routes/settings.export-templates.$id'
import { Route as SettingsEvalDatasetsIdRouteImport } from './routes/settings.eval-datasets.$id'
import { Route as SettingsCatalogSynonymsRouteImport } from './routes/settings.catalog.synonyms'
import { Route as SettingsCatalogSearchRouteImport } from './routes/settings.catalog.search'
import { Route as SettingsCatalogMigrationRouteImport } from './routes/settings.catalog.migration'
import { Route as SettingsCatalogGroupsRouteImport } from './routes/settings.catalog.groups'
import { Route as SettingsCatalogEnrichmentRouteImport } from './routes/settings.catalog.enrichment'
import { Route as SettingsCatalogCompletenessRouteImport } from './routes/settings.catalog.completeness'
import { Route as PortalsIdSearchRouteImport } from './routes/portals.$id.search'
import { Route as PortalsIdRecommendationsRouteImport } from './routes/portals.$id.recommendations'
import { Route as PortalsIdPoliciesRouteImport } from './routes/portals.$id.policies'
import { Route as PortalsIdOverviewRouteImport } from './routes/portals.$id.overview'
import { Route as PortalsIdKeysRouteImport } from './routes/portals.$id.keys'
import { Route as PortalsIdConfigRouteImport } from './routes/portals.$id.config'
import { Route as PortalsIdBuildRouteImport } from './routes/portals.$id.build'
import { Route as PortalsIdApiRouteImport } from './routes/portals.$id.api'
import { Route as PortalsIdAnalyticsRouteImport } from './routes/portals.$id.analytics'
import { Route as ManufacturingProductsIdRouteImport } from './routes/manufacturing.products.$id'
import { Route as DocsPortalWidgetRouteImport } from './routes/docs.portal.widget'
import { Route as DocsPortalEndpointsRouteImport } from './routes/docs.portal.endpoints'
import { Route as DocsPluginsSdkReferenceRouteImport } from './routes/docs.plugins.sdk-reference'
import { Route as DocsPluginsPublishingRouteImport } from './routes/docs.plugins.publishing'
import { Route as DocsPluginsGettingStartedRouteImport } from './routes/docs.plugins.getting-started'
import { Route as DocsPluginsCapabilitiesRouteImport } from './routes/docs.plugins.capabilities'
import { Route as DocsPhase1SalesRouteImport } from './routes/docs.phase1.sales'
import { Route as DocsPhase1ProcurementRouteImport } from './routes/docs.phase1.procurement'
import { Route as DocsPhase1AdminRouteImport } from './routes/docs.phase1.admin'
import { Route as DiagnosticsSessionIdRouteImport } from './routes/diagnostics.session.$id'
import { Route as CommerceShipmentsIdRouteImport } from './routes/commerce.shipments.$id'
import { Route as CommerceReturnsIdRouteImport } from './routes/commerce.returns.$id'
import { Route as CommerceQuotesNewRouteImport } from './routes/commerce.quotes.new'
import { Route as CommerceQuotesIdRouteImport } from './routes/commerce.quotes.$id'
import { Route as CommercePricelistsIdRouteImport } from './routes/commerce.pricelists.$id'
import { Route as CommerceOrdersIdRouteImport } from './routes/commerce.orders.$id'
import { Route as CatalogProductsIdRouteImport } from './routes/catalog.products.$id'
import { Route as CatalogImportReviewsJobIdRouteImport } from './routes/catalog.import-reviews.$jobId'
import { Route as AssistantSessionsIdRouteImport } from './routes/assistant.sessions.$id'
import { Route as AdminWorkspacesIdRouteImport } from './routes/admin.workspaces.$id'
import { Route as AdminInvoicesIdRouteImport } from './routes/admin.invoices.$id'
import { Route as AdminFeaturesIdRouteImport } from './routes/admin.features.$id'
import { Route as AdminEvalRunsRouteImport } from './routes/admin.eval.runs'
import { Route as AdminEvalDatasetsRouteImport } from './routes/admin.eval.datasets'
import { Route as AdminEvalCompareRouteImport } from './routes/admin.eval.compare'
import { Route as AdminBillingIdRouteImport } from './routes/admin.billing.$id'
import { Route as AccountingJournalNewRouteImport } from './routes/accounting.journal.new'
import { Route as AccountingJournalIdRouteImport } from './routes/accounting.journal.$id'
import { Route as AccountingClosePeriodIdRouteImport } from './routes/accounting.close.$periodId'
import { Route as AccountingBankIdRouteImport } from './routes/accounting.bank.$id'
import { Route as AccountingAccountsIdRouteImport } from './routes/accounting.accounts.$id'
import { Route as AdminEvalRunsIdRouteImport } from './routes/admin.eval.runs.$id'
import { Route as AdminEvalDatasetsIdRouteImport } from './routes/admin.eval.datasets.$id'

const WorkItemsRoute = WorkItemsRouteImport.update({
  id: '/work-items',
  path: '/work-items',
  getParentRoute: () => rootRouteImport,
} as any)
const WidgetRoute = WidgetRouteImport.update({
  id: '/widget',
  path: '/widget',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsRoute = SettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const QuotesRoute = QuotesRouteImport.update({
  id: '/quotes',
  path: '/quotes',
  getParentRoute: () => rootRouteImport,
} as any)
const ProductsRoute = ProductsRouteImport.update({
  id: '/products',
  path: '/products',
  getParentRoute: () => rootRouteImport,
} as any)
const PricingRoute = PricingRouteImport.update({
  id: '/pricing',
  path: '/pricing',
  getParentRoute: () => rootRouteImport,
} as any)
const PortalsRoute = PortalsRouteImport.update({
  id: '/portals',
  path: '/portals',
  getParentRoute: () => rootRouteImport,
} as any)
const PartiesRoute = PartiesRouteImport.update({
  id: '/parties',
  path: '/parties',
  getParentRoute: () => rootRouteImport,
} as any)
const OrdersRoute = OrdersRouteImport.update({
  id: '/orders',
  path: '/orders',
  getParentRoute: () => rootRouteImport,
} as any)
const OnboardingRoute = OnboardingRouteImport.update({
  id: '/onboarding',
  path: '/onboarding',
  getParentRoute: () => rootRouteImport,
} as any)
const NotificationsRoute = NotificationsRouteImport.update({
  id: '/notifications',
  path: '/notifications',
  getParentRoute: () => rootRouteImport,
} as any)
const ManufacturingRoute = ManufacturingRouteImport.update({
  id: '/manufacturing',
  path: '/manufacturing',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const DocsRoute = DocsRouteImport.update({
  id: '/docs',
  path: '/docs',
  getParentRoute: () => rootRouteImport,
} as any)
const DiagnosticsRoute = DiagnosticsRouteImport.update({
  id: '/diagnostics',
  path: '/diagnostics',
  getParentRoute: () => rootRouteImport,
} as any)
const DeviceRoute = DeviceRouteImport.update({
  id: '/device',
  path: '/device',
  getParentRoute: () => rootRouteImport,
} as any)
const CommerceRoute = CommerceRouteImport.update({
  id: '/commerce',
  path: '/commerce',
  getParentRoute: () => rootRouteImport,
} as any)
const CatalogRoute = CatalogRouteImport.update({
  id: '/catalog',
  path: '/catalog',
  getParentRoute: () => rootRouteImport,
} as any)
const BackgroundJobsRoute = BackgroundJobsRouteImport.update({
  id: '/background-jobs',
  path: '/background-jobs',
  getParentRoute: () => rootRouteImport,
} as any)
const AssistantRoute = AssistantRouteImport.update({
  id: '/assistant',
  path: '/assistant',
  getParentRoute: () => rootRouteImport,
} as any)
const AdvisorRoute = AdvisorRouteImport.update({
  id: '/advisor',
  path: '/advisor',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRoute = AdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any)
const ActivityRoute = ActivityRouteImport.update({
  id: '/activity',
  path: '/activity',
  getParentRoute: () => rootRouteImport,
} as any)
const AccountingRoute = AccountingRouteImport.update({
  id: '/accounting',
  path: '/accounting',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const WorkItemsIndexRoute = WorkItemsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => WorkItemsRoute,
} as any)
const SettingsIndexRoute = SettingsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => SettingsRoute,
} as any)
const PortalsIndexRoute = PortalsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => PortalsRoute,
} as any)
const PartiesIndexRoute = PartiesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => PartiesRoute,
} as any)
const ManufacturingIndexRoute = ManufacturingIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ManufacturingRoute,
} as any)
const DocsIndexRoute = DocsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => DocsRoute,
} as any)
const DiagnosticsIndexRoute = DiagnosticsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => DiagnosticsRoute,
} as any)
const CommerceIndexRoute = CommerceIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => CommerceRoute,
} as any)
const CatalogIndexRoute = CatalogIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => CatalogRoute,
} as any)
const BackgroundJobsIndexRoute = BackgroundJobsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => BackgroundJobsRoute,
} as any)
const AssistantIndexRoute = AssistantIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AssistantRoute,
} as any)
const AdvisorIndexRoute = AdvisorIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdvisorRoute,
} as any)
const AdminIndexRoute = AdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminRoute,
} as any)
const AccountingIndexRoute = AccountingIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AccountingRoute,
} as any)
const WorkItemsIdRoute = WorkItemsIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => WorkItemsRoute,
} as any)
const SettingsWorkItemsRoute = SettingsWorkItemsRouteImport.update({
  id: '/work-items',
  path: '/work-items',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsWebhooksRoute = SettingsWebhooksRouteImport.update({
  id: '/webhooks',
  path: '/webhooks',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsTokensRoute = SettingsTokensRouteImport.update({
  id: '/tokens',
  path: '/tokens',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsTeamEmailRoute = SettingsTeamEmailRouteImport.update({
  id: '/team-email',
  path: '/team-email',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsTagsRoute = SettingsTagsRouteImport.update({
  id: '/tags',
  path: '/tags',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsSuppliersRoute = SettingsSuppliersRouteImport.update({
  id: '/suppliers',
  path: '/suppliers',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsSubscriptionRoute = SettingsSubscriptionRouteImport.update({
  id: '/subscription',
  path: '/subscription',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsServiceAccountsRoute = SettingsServiceAccountsRouteImport.update({
  id: '/service-accounts',
  path: '/service-accounts',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsRolesRoute = SettingsRolesRouteImport.update({
  id: '/roles',
  path: '/roles',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsProfileRoute = SettingsProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsPluginsRoute = SettingsPluginsRouteImport.update({
  id: '/plugins',
  path: '/plugins',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsOrganizationRoute = SettingsOrganizationRouteImport.update({
  id: '/organization',
  path: '/organization',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsNotificationsRoute = SettingsNotificationsRouteImport.update({
  id: '/notifications',
  path: '/notifications',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsMetalRoute = SettingsMetalRouteImport.update({
  id: '/metal',
  path: '/metal',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsMembersRoute = SettingsMembersRouteImport.update({
  id: '/members',
  path: '/members',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsKnowledgeRoute = SettingsKnowledgeRouteImport.update({
  id: '/knowledge',
  path: '/knowledge',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsIntegrationsRoute = SettingsIntegrationsRouteImport.update({
  id: '/integrations',
  path: '/integrations',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsGeneralRoute = SettingsGeneralRouteImport.update({
  id: '/general',
  path: '/general',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsExportTemplatesRoute = SettingsExportTemplatesRouteImport.update({
  id: '/export-templates',
  path: '/export-templates',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsEvalDatasetsRoute = SettingsEvalDatasetsRouteImport.update({
  id: '/eval-datasets',
  path: '/eval-datasets',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsDiagramRoute = SettingsDiagramRouteImport.update({
  id: '/diagram',
  path: '/diagram',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsComplianceRoute = SettingsComplianceRouteImport.update({
  id: '/compliance',
  path: '/compliance',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsCodeTemplatesRoute = SettingsCodeTemplatesRouteImport.update({
  id: '/code-templates',
  path: '/code-templates',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsChannelsRoute = SettingsChannelsRouteImport.update({
  id: '/channels',
  path: '/channels',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsCatalogRoute = SettingsCatalogRouteImport.update({
  id: '/catalog',
  path: '/catalog',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsAppearanceRoute = SettingsAppearanceRouteImport.update({
  id: '/appearance',
  path: '/appearance',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsAgentProfilesRoute = SettingsAgentProfilesRouteImport.update({
  id: '/agent-profiles',
  path: '/agent-profiles',
  getParentRoute: () => SettingsRoute,
} as any)
const PortalsIdRoute = PortalsIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => PortalsRoute,
} as any)
const PartiesIdRoute = PartiesIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => PartiesRoute,
} as any)
const ManufacturingSopRoute = ManufacturingSopRouteImport.update({
  id: '/sop',
  path: '/sop',
  getParentRoute: () => ManufacturingRoute,
} as any)
const ManufacturingProductionRoute = ManufacturingProductionRouteImport.update({
  id: '/production',
  path: '/production',
  getParentRoute: () => ManufacturingRoute,
} as any)
const ManufacturingExceptionsRoute = ManufacturingExceptionsRouteImport.update({
  id: '/exceptions',
  path: '/exceptions',
  getParentRoute: () => ManufacturingRoute,
} as any)
const ManufacturingBoardRoute = ManufacturingBoardRouteImport.update({
  id: '/board',
  path: '/board',
  getParentRoute: () => ManufacturingRoute,
} as any)
const ManufacturingActionsRoute = ManufacturingActionsRouteImport.update({
  id: '/actions',
  path: '/actions',
  getParentRoute: () => ManufacturingRoute,
} as any)
const KnowledgeDocIdRoute = KnowledgeDocIdRouteImport.update({
  id: '/knowledge-doc/$id',
  path: '/knowledge-doc/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const InviteTokenRoute = InviteTokenRouteImport.update({
  id: '/invite/$token',
  path: '/invite/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const DocsPortalRoute = DocsPortalRouteImport.update({
  id: '/portal',
  path: '/portal',
  getParentRoute: () => DocsRoute,
} as any)
const DocsPluginsRoute = DocsPluginsRouteImport.update({
  id: '/plugins',
  path: '/plugins',
  getParentRoute: () => DocsRoute,
} as any)
const DiagnosticsStorageRoute = DiagnosticsStorageRouteImport.update({
  id: '/storage',
  path: '/storage',
  getParentRoute: () => DiagnosticsRoute,
} as any)
const DiagnosticsSessionsRoute = DiagnosticsSessionsRouteImport.update({
  id: '/sessions',
  path: '/sessions',
  getParentRoute: () => DiagnosticsRoute,
} as any)
const DiagnosticsPoliciesRoute = DiagnosticsPoliciesRouteImport.update({
  id: '/policies',
  path: '/policies',
  getParentRoute: () => DiagnosticsRoute,
} as any)
const DiagnosticsLiveRoute = DiagnosticsLiveRouteImport.update({
  id: '/live',
  path: '/live',
  getParentRoute: () => DiagnosticsRoute,
} as any)
const DiagnosticsExportsRoute = DiagnosticsExportsRouteImport.update({
  id: '/exports',
  path: '/exports',
  getParentRoute: () => DiagnosticsRoute,
} as any)
const DiagnosticsDevicesRoute = DiagnosticsDevicesRouteImport.update({
  id: '/devices',
  path: '/devices',
  getParentRoute: () => DiagnosticsRoute,
} as any)
const DiagnosticsAnalyticsRoute = DiagnosticsAnalyticsRouteImport.update({
  id: '/analytics',
  path: '/analytics',
  getParentRoute: () => DiagnosticsRoute,
} as any)
const DiagnosticsActivityRoute = DiagnosticsActivityRouteImport.update({
  id: '/activity',
  path: '/activity',
  getParentRoute: () => DiagnosticsRoute,
} as any)
const CommerceSubscriptionsRoute = CommerceSubscriptionsRouteImport.update({
  id: '/subscriptions',
  path: '/subscriptions',
  getParentRoute: () => CommerceRoute,
} as any)
const CommerceShipmentsRoute = CommerceShipmentsRouteImport.update({
  id: '/shipments',
  path: '/shipments',
  getParentRoute: () => CommerceRoute,
} as any)
const CommerceReturnsRoute = CommerceReturnsRouteImport.update({
  id: '/returns',
  path: '/returns',
  getParentRoute: () => CommerceRoute,
} as any)
const CommerceQuotesRoute = CommerceQuotesRouteImport.update({
  id: '/quotes',
  path: '/quotes',
  getParentRoute: () => CommerceRoute,
} as any)
const CommercePromotionsRoute = CommercePromotionsRouteImport.update({
  id: '/promotions',
  path: '/promotions',
  getParentRoute: () => CommerceRoute,
} as any)
const CommercePricingRoute = CommercePricingRouteImport.update({
  id: '/pricing',
  path: '/pricing',
  getParentRoute: () => CommerceRoute,
} as any)
const CommercePricelistsRoute = CommercePricelistsRouteImport.update({
  id: '/pricelists',
  path: '/pricelists',
  getParentRoute: () => CommerceRoute,
} as any)
const CommercePortalsRoute = CommercePortalsRouteImport.update({
  id: '/portals',
  path: '/portals',
  getParentRoute: () => CommerceRoute,
} as any)
const CommercePaymentsRoute = CommercePaymentsRouteImport.update({
  id: '/payments',
  path: '/payments',
  getParentRoute: () => CommerceRoute,
} as any)
const CommerceOrdersRoute = CommerceOrdersRouteImport.update({
  id: '/orders',
  path: '/orders',
  getParentRoute: () => CommerceRoute,
} as any)
const CommerceDeliveryRoute = CommerceDeliveryRouteImport.update({
  id: '/delivery',
  path: '/delivery',
  getParentRoute: () => CommerceRoute,
} as any)
const CommerceAnalyticsRoute = CommerceAnalyticsRouteImport.update({
  id: '/analytics',
  path: '/analytics',
  getParentRoute: () => CommerceRoute,
} as any)
const CatalogProductsRoute = CatalogProductsRouteImport.update({
  id: '/products',
  path: '/products',
  getParentRoute: () => CatalogRoute,
} as any)
const CatalogCategoriesRoute = CatalogCategoriesRouteImport.update({
  id: '/categories',
  path: '/categories',
  getParentRoute: () => CatalogRoute,
} as any)
const BackgroundJobsIdRoute = BackgroundJobsIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => BackgroundJobsRoute,
} as any)
const AuthMcpCallbackRoute = AuthMcpCallbackRouteImport.update({
  id: '/auth/mcp-callback',
  path: '/auth/mcp-callback',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthCallbackRoute = AuthCallbackRouteImport.update({
  id: '/auth/callback',
  path: '/auth/callback',
  getParentRoute: () => rootRouteImport,
} as any)
const AssistantMemoryRoute = AssistantMemoryRouteImport.update({
  id: '/memory',
  path: '/memory',
  getParentRoute: () => AssistantRoute,
} as any)
const AssistantThreadIdRoute = AssistantThreadIdRouteImport.update({
  id: '/$threadId',
  path: '/$threadId',
  getParentRoute: () => AssistantRoute,
} as any)
const AdvisorIdRoute = AdvisorIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => AdvisorRoute,
} as any)
const AdminUsersRoute = AdminUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => AdminRoute,
} as any)
const AdminFeaturesRoute = AdminFeaturesRouteImport.update({
  id: '/features',
  path: '/features',
  getParentRoute: () => AdminRoute,
} as any)
const AdminEvalRoute = AdminEvalRouteImport.update({
  id: '/eval',
  path: '/eval',
  getParentRoute: () => AdminRoute,
} as any)
const AdminDiagramRoute = AdminDiagramRouteImport.update({
  id: '/diagram',
  path: '/diagram',
  getParentRoute: () => AdminRoute,
} as any)
const AdminBillingRoute = AdminBillingRouteImport.update({
  id: '/billing',
  path: '/billing',
  getParentRoute: () => AdminRoute,
} as any)
const AdminAuditRoute = AdminAuditRouteImport.update({
  id: '/audit',
  path: '/audit',
  getParentRoute: () => AdminRoute,
} as any)
const AccountingStatementsRoute = AccountingStatementsRouteImport.update({
  id: '/statements',
  path: '/statements',
  getParentRoute: () => AccountingRoute,
} as any)
const AccountingSchemasRoute = AccountingSchemasRouteImport.update({
  id: '/schemas',
  path: '/schemas',
  getParentRoute: () => AccountingRoute,
} as any)
const AccountingRecurringRoute = AccountingRecurringRouteImport.update({
  id: '/recurring',
  path: '/recurring',
  getParentRoute: () => AccountingRoute,
} as any)
const AccountingReceivablesRoute = AccountingReceivablesRouteImport.update({
  id: '/receivables',
  path: '/receivables',
  getParentRoute: () => AccountingRoute,
} as any)
const AccountingQualityCheckRoute = AccountingQualityCheckRouteImport.update({
  id: '/quality-check',
  path: '/quality-check',
  getParentRoute: () => AccountingRoute,
} as any)
const AccountingPayablesRoute = AccountingPayablesRouteImport.update({
  id: '/payables',
  path: '/payables',
  getParentRoute: () => AccountingRoute,
} as any)
const AccountingOperationsRoute = AccountingOperationsRouteImport.update({
  id: '/operations',
  path: '/operations',
  getParentRoute: () => AccountingRoute,
} as any)
const AccountingCrosstabRoute = AccountingCrosstabRouteImport.update({
  id: '/crosstab',
  path: '/crosstab',
  getParentRoute: () => AccountingRoute,
} as any)
const AccountingCounterpartyReconRoute =
  AccountingCounterpartyReconRouteImport.update({
    id: '/counterparty-recon',
    path: '/counterparty-recon',
    getParentRoute: () => AccountingRoute,
  } as any)
const AccountingConsolidationRoute = AccountingConsolidationRouteImport.update({
  id: '/consolidation',
  path: '/consolidation',
  getParentRoute: () => AccountingRoute,
} as any)
const AccountingCloseRoute = AccountingCloseRouteImport.update({
  id: '/close',
  path: '/close',
  getParentRoute: () => AccountingRoute,
} as any)
const AccountingBudgetRoute = AccountingBudgetRouteImport.update({
  id: '/budget',
  path: '/budget',
  getParentRoute: () => AccountingRoute,
} as any)
const AccountingBankRoute = AccountingBankRouteImport.update({
  id: '/bank',
  path: '/bank',
  getParentRoute: () => AccountingRoute,
} as any)
const AccountingAssetsRoute = AccountingAssetsRouteImport.update({
  id: '/assets',
  path: '/assets',
  getParentRoute: () => AccountingRoute,
} as any)
const AccountingAnalysisRoute = AccountingAnalysisRouteImport.update({
  id: '/analysis',
  path: '/analysis',
  getParentRoute: () => AccountingRoute,
} as any)
const AccountingAccountsRoute = AccountingAccountsRouteImport.update({
  id: '/accounts',
  path: '/accounts',
  getParentRoute: () => AccountingRoute,
} as any)
const SettingsSubscriptionIndexRoute =
  SettingsSubscriptionIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => SettingsSubscriptionRoute,
  } as any)
const SettingsPluginsIndexRoute = SettingsPluginsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => SettingsPluginsRoute,
} as any)
const DocsPortalIndexRoute = DocsPortalIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => DocsPortalRoute,
} as any)
const DocsPluginsIndexRoute = DocsPluginsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => DocsPluginsRoute,
} as any)
const DocsPhase1IndexRoute = DocsPhase1IndexRouteImport.update({
  id: '/phase1/',
  path: '/phase1/',
  getParentRoute: () => DocsRoute,
} as any)
const CommerceShipmentsIndexRoute = CommerceShipmentsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => CommerceShipmentsRoute,
} as any)
const CommerceReturnsIndexRoute = CommerceReturnsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => CommerceReturnsRoute,
} as any)
const CommerceQuotesIndexRoute = CommerceQuotesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => CommerceQuotesRoute,
} as any)
const CommerceOrdersIndexRoute = CommerceOrdersIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => CommerceOrdersRoute,
} as any)
const CatalogProductsIndexRoute = CatalogProductsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => CatalogProductsRoute,
} as any)
const AdminWorkspacesIndexRoute = AdminWorkspacesIndexRouteImport.update({
  id: '/workspaces/',
  path: '/workspaces/',
  getParentRoute: () => AdminRoute,
} as any)
const AdminFeaturesIndexRoute = AdminFeaturesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminFeaturesRoute,
} as any)
const AdminEvalIndexRoute = AdminEvalIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminEvalRoute,
} as any)
const AccountingJournalIndexRoute = AccountingJournalIndexRouteImport.update({
  id: '/journal/',
  path: '/journal/',
  getParentRoute: () => AccountingRoute,
} as any)
const SettingsSubscriptionBillingRoute =
  SettingsSubscriptionBillingRouteImport.update({
    id: '/billing',
    path: '/billing',
    getParentRoute: () => SettingsSubscriptionRoute,
  } as any)
const SettingsPluginsMarketplaceRoute =
  SettingsPluginsMarketplaceRouteImport.update({
    id: '/marketplace',
    path: '/marketplace',
    getParentRoute: () => SettingsPluginsRoute,
  } as any)
const SettingsPluginsDeveloperRoute =
  SettingsPluginsDeveloperRouteImport.update({
    id: '/developer',
    path: '/developer',
    getParentRoute: () => SettingsPluginsRoute,
  } as any)
const SettingsPluginsPluginIdRoute = SettingsPluginsPluginIdRouteImport.update({
  id: '/$pluginId',
  path: '/$pluginId',
  getParentRoute: () => SettingsPluginsRoute,
} as any)
const SettingsExportTemplatesIdRoute =
  SettingsExportTemplatesIdRouteImport.update({
    id: '/$id',
    path: '/$id',
    getParentRoute: () => SettingsExportTemplatesRoute,
  } as any)
const SettingsEvalDatasetsIdRoute = SettingsEvalDatasetsIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => SettingsEvalDatasetsRoute,
} as any)
const SettingsCatalogSynonymsRoute = SettingsCatalogSynonymsRouteImport.update({
  id: '/synonyms',
  path: '/synonyms',
  getParentRoute: () => SettingsCatalogRoute,
} as any)
const SettingsCatalogSearchRoute = SettingsCatalogSearchRouteImport.update({
  id: '/search',
  path: '/search',
  getParentRoute: () => SettingsCatalogRoute,
} as any)
const SettingsCatalogMigrationRoute =
  SettingsCatalogMigrationRouteImport.update({
    id: '/migration',
    path: '/migration',
    getParentRoute: () => SettingsCatalogRoute,
  } as any)
const SettingsCatalogGroupsRoute = SettingsCatalogGroupsRouteImport.update({
  id: '/groups',
  path: '/groups',
  getParentRoute: () => SettingsCatalogRoute,
} as any)
const SettingsCatalogEnrichmentRoute =
  SettingsCatalogEnrichmentRouteImport.update({
    id: '/enrichment',
    path: '/enrichment',
    getParentRoute: () => SettingsCatalogRoute,
  } as any)
const SettingsCatalogCompletenessRoute =
  SettingsCatalogCompletenessRouteImport.update({
    id: '/completeness',
    path: '/completeness',
    getParentRoute: () => SettingsCatalogRoute,
  } as any)
const PortalsIdSearchRoute = PortalsIdSearchRouteImport.update({
  id: '/search',
  path: '/search',
  getParentRoute: () => PortalsIdRoute,
} as any)
const PortalsIdRecommendationsRoute =
  PortalsIdRecommendationsRouteImport.update({
    id: '/recommendations',
    path: '/recommendations',
    getParentRoute: () => PortalsIdRoute,
  } as any)
const PortalsIdPoliciesRoute = PortalsIdPoliciesRouteImport.update({
  id: '/policies',
  path: '/policies',
  getParentRoute: () => PortalsIdRoute,
} as any)
const PortalsIdOverviewRoute = PortalsIdOverviewRouteImport.update({
  id: '/overview',
  path: '/overview',
  getParentRoute: () => PortalsIdRoute,
} as any)
const PortalsIdKeysRoute = PortalsIdKeysRouteImport.update({
  id: '/keys',
  path: '/keys',
  getParentRoute: () => PortalsIdRoute,
} as any)
const PortalsIdConfigRoute = PortalsIdConfigRouteImport.update({
  id: '/config',
  path: '/config',
  getParentRoute: () => PortalsIdRoute,
} as any)
const PortalsIdBuildRoute = PortalsIdBuildRouteImport.update({
  id: '/build',
  path: '/build',
  getParentRoute: () => PortalsIdRoute,
} as any)
const PortalsIdApiRoute = PortalsIdApiRouteImport.update({
  id: '/api',
  path: '/api',
  getParentRoute: () => PortalsIdRoute,
} as any)
const PortalsIdAnalyticsRoute = PortalsIdAnalyticsRouteImport.update({
  id: '/analytics',
  path: '/analytics',
  getParentRoute: () => PortalsIdRoute,
} as any)
const ManufacturingProductsIdRoute = ManufacturingProductsIdRouteImport.update({
  id: '/products/$id',
  path: '/products/$id',
  getParentRoute: () => ManufacturingRoute,
} as any)
const DocsPortalWidgetRoute = DocsPortalWidgetRouteImport.update({
  id: '/widget',
  path: '/widget',
  getParentRoute: () => DocsPortalRoute,
} as any)
const DocsPortalEndpointsRoute = DocsPortalEndpointsRouteImport.update({
  id: '/endpoints',
  path: '/endpoints',
  getParentRoute: () => DocsPortalRoute,
} as any)
const DocsPluginsSdkReferenceRoute = DocsPluginsSdkReferenceRouteImport.update({
  id: '/sdk-reference',
  path: '/sdk-reference',
  getParentRoute: () => DocsPluginsRoute,
} as any)
const DocsPluginsPublishingRoute = DocsPluginsPublishingRouteImport.update({
  id: '/publishing',
  path: '/publishing',
  getParentRoute: () => DocsPluginsRoute,
} as any)
const DocsPluginsGettingStartedRoute =
  DocsPluginsGettingStartedRouteImport.update({
    id: '/getting-started',
    path: '/getting-started',
    getParentRoute: () => DocsPluginsRoute,
  } as any)
const DocsPluginsCapabilitiesRoute = DocsPluginsCapabilitiesRouteImport.update({
  id: '/capabilities',
  path: '/capabilities',
  getParentRoute: () => DocsPluginsRoute,
} as any)
const DocsPhase1SalesRoute = DocsPhase1SalesRouteImport.update({
  id: '/phase1/sales',
  path: '/phase1/sales',
  getParentRoute: () => DocsRoute,
} as any)
const DocsPhase1ProcurementRoute = DocsPhase1ProcurementRouteImport.update({
  id: '/phase1/procurement',
  path: '/phase1/procurement',
  getParentRoute: () => DocsRoute,
} as any)
const DocsPhase1AdminRoute = DocsPhase1AdminRouteImport.update({
  id: '/phase1/admin',
  path: '/phase1/admin',
  getParentRoute: () => DocsRoute,
} as any)
const DiagnosticsSessionIdRoute = DiagnosticsSessionIdRouteImport.update({
  id: '/session/$id',
  path: '/session/$id',
  getParentRoute: () => DiagnosticsRoute,
} as any)
const CommerceShipmentsIdRoute = CommerceShipmentsIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => CommerceShipmentsRoute,
} as any)
const CommerceReturnsIdRoute = CommerceReturnsIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => CommerceReturnsRoute,
} as any)
const CommerceQuotesNewRoute = CommerceQuotesNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => CommerceQuotesRoute,
} as any)
const CommerceQuotesIdRoute = CommerceQuotesIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => CommerceQuotesRoute,
} as any)
const CommercePricelistsIdRoute = CommercePricelistsIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => CommercePricelistsRoute,
} as any)
const CommerceOrdersIdRoute = CommerceOrdersIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => CommerceOrdersRoute,
} as any)
const CatalogProductsIdRoute = CatalogProductsIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => CatalogProductsRoute,
} as any)
const CatalogImportReviewsJobIdRoute =
  CatalogImportReviewsJobIdRouteImport.update({
    id: '/import-reviews/$jobId',
    path: '/import-reviews/$jobId',
    getParentRoute: () => CatalogRoute,
  } as any)
const AssistantSessionsIdRoute = AssistantSessionsIdRouteImport.update({
  id: '/sessions/$id',
  path: '/sessions/$id',
  getParentRoute: () => AssistantRoute,
} as any)
const AdminWorkspacesIdRoute = AdminWorkspacesIdRouteImport.update({
  id: '/workspaces/$id',
  path: '/workspaces/$id',
  getParentRoute: () => AdminRoute,
} as any)
const AdminInvoicesIdRoute = AdminInvoicesIdRouteImport.update({
  id: '/invoices/$id',
  path: '/invoices/$id',
  getParentRoute: () => AdminRoute,
} as any)
const AdminFeaturesIdRoute = AdminFeaturesIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => AdminFeaturesRoute,
} as any)
const AdminEvalRunsRoute = AdminEvalRunsRouteImport.update({
  id: '/runs',
  path: '/runs',
  getParentRoute: () => AdminEvalRoute,
} as any)
const AdminEvalDatasetsRoute = AdminEvalDatasetsRouteImport.update({
  id: '/datasets',
  path: '/datasets',
  getParentRoute: () => AdminEvalRoute,
} as any)
const AdminEvalCompareRoute = AdminEvalCompareRouteImport.update({
  id: '/compare',
  path: '/compare',
  getParentRoute: () => AdminEvalRoute,
} as any)
const AdminBillingIdRoute = AdminBillingIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => AdminBillingRoute,
} as any)
const AccountingJournalNewRoute = AccountingJournalNewRouteImport.update({
  id: '/journal/new',
  path: '/journal/new',
  getParentRoute: () => AccountingRoute,
} as any)
const AccountingJournalIdRoute = AccountingJournalIdRouteImport.update({
  id: '/journal/$id',
  path: '/journal/$id',
  getParentRoute: () => AccountingRoute,
} as any)
const AccountingClosePeriodIdRoute = AccountingClosePeriodIdRouteImport.update({
  id: '/$periodId',
  path: '/$periodId',
  getParentRoute: () => AccountingCloseRoute,
} as any)
const AccountingBankIdRoute = AccountingBankIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => AccountingBankRoute,
} as any)
const AccountingAccountsIdRoute = AccountingAccountsIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => AccountingAccountsRoute,
} as any)
const AdminEvalRunsIdRoute = AdminEvalRunsIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => AdminEvalRunsRoute,
} as any)
const AdminEvalDatasetsIdRoute = AdminEvalDatasetsIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => AdminEvalDatasetsRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/accounting': typeof AccountingRouteWithChildren
  '/activity': typeof ActivityRoute
  '/admin': typeof AdminRouteWithChildren
  '/advisor': typeof AdvisorRouteWithChildren
  '/assistant': typeof AssistantRouteWithChildren
  '/background-jobs': typeof BackgroundJobsRouteWithChildren
  '/catalog': typeof CatalogRouteWithChildren
  '/commerce': typeof CommerceRouteWithChildren
  '/device': typeof DeviceRoute
  '/diagnostics': typeof DiagnosticsRouteWithChildren
  '/docs': typeof DocsRouteWithChildren
  '/login': typeof LoginRoute
  '/manufacturing': typeof ManufacturingRouteWithChildren
  '/notifications': typeof NotificationsRoute
  '/onboarding': typeof OnboardingRoute
  '/orders': typeof OrdersRoute
  '/parties': typeof PartiesRouteWithChildren
  '/portals': typeof PortalsRouteWithChildren
  '/pricing': typeof PricingRoute
  '/products': typeof ProductsRoute
  '/quotes': typeof QuotesRoute
  '/settings': typeof SettingsRouteWithChildren
  '/widget': typeof WidgetRoute
  '/work-items': typeof WorkItemsRouteWithChildren
  '/accounting/accounts': typeof AccountingAccountsRouteWithChildren
  '/accounting/analysis': typeof AccountingAnalysisRoute
  '/accounting/assets': typeof AccountingAssetsRoute
  '/accounting/bank': typeof AccountingBankRouteWithChildren
  '/accounting/budget': typeof AccountingBudgetRoute
  '/accounting/close': typeof AccountingCloseRouteWithChildren
  '/accounting/consolidation': typeof AccountingConsolidationRoute
  '/accounting/counterparty-recon': typeof AccountingCounterpartyReconRoute
  '/accounting/crosstab': typeof AccountingCrosstabRoute
  '/accounting/operations': typeof AccountingOperationsRoute
  '/accounting/payables': typeof AccountingPayablesRoute
  '/accounting/quality-check': typeof AccountingQualityCheckRoute
  '/accounting/receivables': typeof AccountingReceivablesRoute
  '/accounting/recurring': typeof AccountingRecurringRoute
  '/accounting/schemas': typeof AccountingSchemasRoute
  '/accounting/statements': typeof AccountingStatementsRoute
  '/admin/audit': typeof AdminAuditRoute
  '/admin/billing': typeof AdminBillingRouteWithChildren
  '/admin/diagram': typeof AdminDiagramRoute
  '/admin/eval': typeof AdminEvalRouteWithChildren
  '/admin/features': typeof AdminFeaturesRouteWithChildren
  '/admin/users': typeof AdminUsersRoute
  '/advisor/$id': typeof AdvisorIdRoute
  '/assistant/$threadId': typeof AssistantThreadIdRoute
  '/assistant/memory': typeof AssistantMemoryRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/auth/mcp-callback': typeof AuthMcpCallbackRoute
  '/background-jobs/$id': typeof BackgroundJobsIdRoute
  '/catalog/categories': typeof CatalogCategoriesRoute
  '/catalog/products': typeof CatalogProductsRouteWithChildren
  '/commerce/analytics': typeof CommerceAnalyticsRoute
  '/commerce/delivery': typeof CommerceDeliveryRoute
  '/commerce/orders': typeof CommerceOrdersRouteWithChildren
  '/commerce/payments': typeof CommercePaymentsRoute
  '/commerce/portals': typeof CommercePortalsRoute
  '/commerce/pricelists': typeof CommercePricelistsRouteWithChildren
  '/commerce/pricing': typeof CommercePricingRoute
  '/commerce/promotions': typeof CommercePromotionsRoute
  '/commerce/quotes': typeof CommerceQuotesRouteWithChildren
  '/commerce/returns': typeof CommerceReturnsRouteWithChildren
  '/commerce/shipments': typeof CommerceShipmentsRouteWithChildren
  '/commerce/subscriptions': typeof CommerceSubscriptionsRoute
  '/diagnostics/activity': typeof DiagnosticsActivityRoute
  '/diagnostics/analytics': typeof DiagnosticsAnalyticsRoute
  '/diagnostics/devices': typeof DiagnosticsDevicesRoute
  '/diagnostics/exports': typeof DiagnosticsExportsRoute
  '/diagnostics/live': typeof DiagnosticsLiveRoute
  '/diagnostics/policies': typeof DiagnosticsPoliciesRoute
  '/diagnostics/sessions': typeof DiagnosticsSessionsRoute
  '/diagnostics/storage': typeof DiagnosticsStorageRoute
  '/docs/plugins': typeof DocsPluginsRouteWithChildren
  '/docs/portal': typeof DocsPortalRouteWithChildren
  '/invite/$token': typeof InviteTokenRoute
  '/knowledge-doc/$id': typeof KnowledgeDocIdRoute
  '/manufacturing/actions': typeof ManufacturingActionsRoute
  '/manufacturing/board': typeof ManufacturingBoardRoute
  '/manufacturing/exceptions': typeof ManufacturingExceptionsRoute
  '/manufacturing/production': typeof ManufacturingProductionRoute
  '/manufacturing/sop': typeof ManufacturingSopRoute
  '/parties/$id': typeof PartiesIdRoute
  '/portals/$id': typeof PortalsIdRouteWithChildren
  '/settings/agent-profiles': typeof SettingsAgentProfilesRoute
  '/settings/appearance': typeof SettingsAppearanceRoute
  '/settings/catalog': typeof SettingsCatalogRouteWithChildren
  '/settings/channels': typeof SettingsChannelsRoute
  '/settings/code-templates': typeof SettingsCodeTemplatesRoute
  '/settings/compliance': typeof SettingsComplianceRoute
  '/settings/diagram': typeof SettingsDiagramRoute
  '/settings/eval-datasets': typeof SettingsEvalDatasetsRouteWithChildren
  '/settings/export-templates': typeof SettingsExportTemplatesRouteWithChildren
  '/settings/general': typeof SettingsGeneralRoute
  '/settings/integrations': typeof SettingsIntegrationsRoute
  '/settings/knowledge': typeof SettingsKnowledgeRoute
  '/settings/members': typeof SettingsMembersRoute
  '/settings/metal': typeof SettingsMetalRoute
  '/settings/notifications': typeof SettingsNotificationsRoute
  '/settings/organization': typeof SettingsOrganizationRoute
  '/settings/plugins': typeof SettingsPluginsRouteWithChildren
  '/settings/profile': typeof SettingsProfileRoute
  '/settings/roles': typeof SettingsRolesRoute
  '/settings/service-accounts': typeof SettingsServiceAccountsRoute
  '/settings/subscription': typeof SettingsSubscriptionRouteWithChildren
  '/settings/suppliers': typeof SettingsSuppliersRoute
  '/settings/tags': typeof SettingsTagsRoute
  '/settings/team-email': typeof SettingsTeamEmailRoute
  '/settings/tokens': typeof SettingsTokensRoute
  '/settings/webhooks': typeof SettingsWebhooksRoute
  '/settings/work-items': typeof SettingsWorkItemsRoute
  '/work-items/$id': typeof WorkItemsIdRoute
  '/accounting/': typeof AccountingIndexRoute
  '/admin/': typeof AdminIndexRoute
  '/advisor/': typeof AdvisorIndexRoute
  '/assistant/': typeof AssistantIndexRoute
  '/background-jobs/': typeof BackgroundJobsIndexRoute
  '/catalog/': typeof CatalogIndexRoute
  '/commerce/': typeof CommerceIndexRoute
  '/diagnostics/': typeof DiagnosticsIndexRoute
  '/docs/': typeof DocsIndexRoute
  '/manufacturing/': typeof ManufacturingIndexRoute
  '/parties/': typeof PartiesIndexRoute
  '/portals/': typeof PortalsIndexRoute
  '/settings/': typeof SettingsIndexRoute
  '/work-items/': typeof WorkItemsIndexRoute
  '/accounting/accounts/$id': typeof AccountingAccountsIdRoute
  '/accounting/bank/$id': typeof AccountingBankIdRoute
  '/accounting/close/$periodId': typeof AccountingClosePeriodIdRoute
  '/accounting/journal/$id': typeof AccountingJournalIdRoute
  '/accounting/journal/new': typeof AccountingJournalNewRoute
  '/admin/billing/$id': typeof AdminBillingIdRoute
  '/admin/eval/compare': typeof AdminEvalCompareRoute
  '/admin/eval/datasets': typeof AdminEvalDatasetsRouteWithChildren
  '/admin/eval/runs': typeof AdminEvalRunsRouteWithChildren
  '/admin/features/$id': typeof AdminFeaturesIdRoute
  '/admin/invoices/$id': typeof AdminInvoicesIdRoute
  '/admin/workspaces/$id': typeof AdminWorkspacesIdRoute
  '/assistant/sessions/$id': typeof AssistantSessionsIdRoute
  '/catalog/import-reviews/$jobId': typeof CatalogImportReviewsJobIdRoute
  '/catalog/products/$id': typeof CatalogProductsIdRoute
  '/commerce/orders/$id': typeof CommerceOrdersIdRoute
  '/commerce/pricelists/$id': typeof CommercePricelistsIdRoute
  '/commerce/quotes/$id': typeof CommerceQuotesIdRoute
  '/commerce/quotes/new': typeof CommerceQuotesNewRoute
  '/commerce/returns/$id': typeof CommerceReturnsIdRoute
  '/commerce/shipments/$id': typeof CommerceShipmentsIdRoute
  '/diagnostics/session/$id': typeof DiagnosticsSessionIdRoute
  '/docs/phase1/admin': typeof DocsPhase1AdminRoute
  '/docs/phase1/procurement': typeof DocsPhase1ProcurementRoute
  '/docs/phase1/sales': typeof DocsPhase1SalesRoute
  '/docs/plugins/capabilities': typeof DocsPluginsCapabilitiesRoute
  '/docs/plugins/getting-started': typeof DocsPluginsGettingStartedRoute
  '/docs/plugins/publishing': typeof DocsPluginsPublishingRoute
  '/docs/plugins/sdk-reference': typeof DocsPluginsSdkReferenceRoute
  '/docs/portal/endpoints': typeof DocsPortalEndpointsRoute
  '/docs/portal/widget': typeof DocsPortalWidgetRoute
  '/manufacturing/products/$id': typeof ManufacturingProductsIdRoute
  '/portals/$id/analytics': typeof PortalsIdAnalyticsRoute
  '/portals/$id/api': typeof PortalsIdApiRoute
  '/portals/$id/build': typeof PortalsIdBuildRoute
  '/portals/$id/config': typeof PortalsIdConfigRoute
  '/portals/$id/keys': typeof PortalsIdKeysRoute
  '/portals/$id/overview': typeof PortalsIdOverviewRoute
  '/portals/$id/policies': typeof PortalsIdPoliciesRoute
  '/portals/$id/recommendations': typeof PortalsIdRecommendationsRoute
  '/portals/$id/search': typeof PortalsIdSearchRoute
  '/settings/catalog/completeness': typeof SettingsCatalogCompletenessRoute
  '/settings/catalog/enrichment': typeof SettingsCatalogEnrichmentRoute
  '/settings/catalog/groups': typeof SettingsCatalogGroupsRoute
  '/settings/catalog/migration': typeof SettingsCatalogMigrationRoute
  '/settings/catalog/search': typeof SettingsCatalogSearchRoute
  '/settings/catalog/synonyms': typeof SettingsCatalogSynonymsRoute
  '/settings/eval-datasets/$id': typeof SettingsEvalDatasetsIdRoute
  '/settings/export-templates/$id': typeof SettingsExportTemplatesIdRoute
  '/settings/plugins/$pluginId': typeof SettingsPluginsPluginIdRoute
  '/settings/plugins/developer': typeof SettingsPluginsDeveloperRoute
  '/settings/plugins/marketplace': typeof SettingsPluginsMarketplaceRoute
  '/settings/subscription/billing': typeof SettingsSubscriptionBillingRoute
  '/accounting/journal/': typeof AccountingJournalIndexRoute
  '/admin/eval/': typeof AdminEvalIndexRoute
  '/admin/features/': typeof AdminFeaturesIndexRoute
  '/admin/workspaces/': typeof AdminWorkspacesIndexRoute
  '/catalog/products/': typeof CatalogProductsIndexRoute
  '/commerce/orders/': typeof CommerceOrdersIndexRoute
  '/commerce/quotes/': typeof CommerceQuotesIndexRoute
  '/commerce/returns/': typeof CommerceReturnsIndexRoute
  '/commerce/shipments/': typeof CommerceShipmentsIndexRoute
  '/docs/phase1/': typeof DocsPhase1IndexRoute
  '/docs/plugins/': typeof DocsPluginsIndexRoute
  '/docs/portal/': typeof DocsPortalIndexRoute
  '/settings/plugins/': typeof SettingsPluginsIndexRoute
  '/settings/subscription/': typeof SettingsSubscriptionIndexRoute
  '/admin/eval/datasets/$id': typeof AdminEvalDatasetsIdRoute
  '/admin/eval/runs/$id': typeof AdminEvalRunsIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/activity': typeof ActivityRoute
  '/device': typeof DeviceRoute
  '/login': typeof LoginRoute
  '/notifications': typeof NotificationsRoute
  '/onboarding': typeof OnboardingRoute
  '/orders': typeof OrdersRoute
  '/pricing': typeof PricingRoute
  '/products': typeof ProductsRoute
  '/quotes': typeof QuotesRoute
  '/widget': typeof WidgetRoute
  '/accounting/accounts': typeof AccountingAccountsRouteWithChildren
  '/accounting/analysis': typeof AccountingAnalysisRoute
  '/accounting/assets': typeof AccountingAssetsRoute
  '/accounting/bank': typeof AccountingBankRouteWithChildren
  '/accounting/budget': typeof AccountingBudgetRoute
  '/accounting/close': typeof AccountingCloseRouteWithChildren
  '/accounting/consolidation': typeof AccountingConsolidationRoute
  '/accounting/counterparty-recon': typeof AccountingCounterpartyReconRoute
  '/accounting/crosstab': typeof AccountingCrosstabRoute
  '/accounting/operations': typeof AccountingOperationsRoute
  '/accounting/payables': typeof AccountingPayablesRoute
  '/accounting/quality-check': typeof AccountingQualityCheckRoute
  '/accounting/receivables': typeof AccountingReceivablesRoute
  '/accounting/recurring': typeof AccountingRecurringRoute
  '/accounting/schemas': typeof AccountingSchemasRoute
  '/accounting/statements': typeof AccountingStatementsRoute
  '/admin/audit': typeof AdminAuditRoute
  '/admin/billing': typeof AdminBillingRouteWithChildren
  '/admin/diagram': typeof AdminDiagramRoute
  '/admin/users': typeof AdminUsersRoute
  '/advisor/$id': typeof AdvisorIdRoute
  '/assistant/$threadId': typeof AssistantThreadIdRoute
  '/assistant/memory': typeof AssistantMemoryRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/auth/mcp-callback': typeof AuthMcpCallbackRoute
  '/background-jobs/$id': typeof BackgroundJobsIdRoute
  '/catalog/categories': typeof CatalogCategoriesRoute
  '/commerce/analytics': typeof CommerceAnalyticsRoute
  '/commerce/delivery': typeof CommerceDeliveryRoute
  '/commerce/payments': typeof CommercePaymentsRoute
  '/commerce/portals': typeof CommercePortalsRoute
  '/commerce/pricelists': typeof CommercePricelistsRouteWithChildren
  '/commerce/pricing': typeof CommercePricingRoute
  '/commerce/promotions': typeof CommercePromotionsRoute
  '/commerce/subscriptions': typeof CommerceSubscriptionsRoute
  '/diagnostics/activity': typeof DiagnosticsActivityRoute
  '/diagnostics/analytics': typeof DiagnosticsAnalyticsRoute
  '/diagnostics/devices': typeof DiagnosticsDevicesRoute
  '/diagnostics/exports': typeof DiagnosticsExportsRoute
  '/diagnostics/live': typeof DiagnosticsLiveRoute
  '/diagnostics/policies': typeof DiagnosticsPoliciesRoute
  '/diagnostics/sessions': typeof DiagnosticsSessionsRoute
  '/diagnostics/storage': typeof DiagnosticsStorageRoute
  '/invite/$token': typeof InviteTokenRoute
  '/knowledge-doc/$id': typeof KnowledgeDocIdRoute
  '/manufacturing/actions': typeof ManufacturingActionsRoute
  '/manufacturing/board': typeof ManufacturingBoardRoute
  '/manufacturing/exceptions': typeof ManufacturingExceptionsRoute
  '/manufacturing/production': typeof ManufacturingProductionRoute
  '/manufacturing/sop': typeof ManufacturingSopRoute
  '/parties/$id': typeof PartiesIdRoute
  '/portals/$id': typeof PortalsIdRouteWithChildren
  '/settings/agent-profiles': typeof SettingsAgentProfilesRoute
  '/settings/appearance': typeof SettingsAppearanceRoute
  '/settings/catalog': typeof SettingsCatalogRouteWithChildren
  '/settings/channels': typeof SettingsChannelsRoute
  '/settings/code-templates': typeof SettingsCodeTemplatesRoute
  '/settings/compliance': typeof SettingsComplianceRoute
  '/settings/diagram': typeof SettingsDiagramRoute
  '/settings/eval-datasets': typeof SettingsEvalDatasetsRouteWithChildren
  '/settings/export-templates': typeof SettingsExportTemplatesRouteWithChildren
  '/settings/general': typeof SettingsGeneralRoute
  '/settings/integrations': typeof SettingsIntegrationsRoute
  '/settings/knowledge': typeof SettingsKnowledgeRoute
  '/settings/members': typeof SettingsMembersRoute
  '/settings/metal': typeof SettingsMetalRoute
  '/settings/notifications': typeof SettingsNotificationsRoute
  '/settings/organization': typeof SettingsOrganizationRoute
  '/settings/profile': typeof SettingsProfileRoute
  '/settings/roles': typeof SettingsRolesRoute
  '/settings/service-accounts': typeof SettingsServiceAccountsRoute
  '/settings/suppliers': typeof SettingsSuppliersRoute
  '/settings/tags': typeof SettingsTagsRoute
  '/settings/team-email': typeof SettingsTeamEmailRoute
  '/settings/tokens': typeof SettingsTokensRoute
  '/settings/webhooks': typeof SettingsWebhooksRoute
  '/settings/work-items': typeof SettingsWorkItemsRoute
  '/work-items/$id': typeof WorkItemsIdRoute
  '/accounting': typeof AccountingIndexRoute
  '/admin': typeof AdminIndexRoute
  '/advisor': typeof AdvisorIndexRoute
  '/assistant': typeof AssistantIndexRoute
  '/background-jobs': typeof BackgroundJobsIndexRoute
  '/catalog': typeof CatalogIndexRoute
  '/commerce': typeof CommerceIndexRoute
  '/diagnostics': typeof DiagnosticsIndexRoute
  '/docs': typeof DocsIndexRoute
  '/manufacturing': typeof ManufacturingIndexRoute
  '/parties': typeof PartiesIndexRoute
  '/portals': typeof PortalsIndexRoute
  '/settings': typeof SettingsIndexRoute
  '/work-items': typeof WorkItemsIndexRoute
  '/accounting/accounts/$id': typeof AccountingAccountsIdRoute
  '/accounting/bank/$id': typeof AccountingBankIdRoute
  '/accounting/close/$periodId': typeof AccountingClosePeriodIdRoute
  '/accounting/journal/$id': typeof AccountingJournalIdRoute
  '/accounting/journal/new': typeof AccountingJournalNewRoute
  '/admin/billing/$id': typeof AdminBillingIdRoute
  '/admin/eval/compare': typeof AdminEvalCompareRoute
  '/admin/eval/datasets': typeof AdminEvalDatasetsRouteWithChildren
  '/admin/eval/runs': typeof AdminEvalRunsRouteWithChildren
  '/admin/features/$id': typeof AdminFeaturesIdRoute
  '/admin/invoices/$id': typeof AdminInvoicesIdRoute
  '/admin/workspaces/$id': typeof AdminWorkspacesIdRoute
  '/assistant/sessions/$id': typeof AssistantSessionsIdRoute
  '/catalog/import-reviews/$jobId': typeof CatalogImportReviewsJobIdRoute
  '/catalog/products/$id': typeof CatalogProductsIdRoute
  '/commerce/orders/$id': typeof CommerceOrdersIdRoute
  '/commerce/pricelists/$id': typeof CommercePricelistsIdRoute
  '/commerce/quotes/$id': typeof CommerceQuotesIdRoute
  '/commerce/quotes/new': typeof CommerceQuotesNewRoute
  '/commerce/returns/$id': typeof CommerceReturnsIdRoute
  '/commerce/shipments/$id': typeof CommerceShipmentsIdRoute
  '/diagnostics/session/$id': typeof DiagnosticsSessionIdRoute
  '/docs/phase1/admin': typeof DocsPhase1AdminRoute
  '/docs/phase1/procurement': typeof DocsPhase1ProcurementRoute
  '/docs/phase1/sales': typeof DocsPhase1SalesRoute
  '/docs/plugins/capabilities': typeof DocsPluginsCapabilitiesRoute
  '/docs/plugins/getting-started': typeof DocsPluginsGettingStartedRoute
  '/docs/plugins/publishing': typeof DocsPluginsPublishingRoute
  '/docs/plugins/sdk-reference': typeof DocsPluginsSdkReferenceRoute
  '/docs/portal/endpoints': typeof DocsPortalEndpointsRoute
  '/docs/portal/widget': typeof DocsPortalWidgetRoute
  '/manufacturing/products/$id': typeof ManufacturingProductsIdRoute
  '/portals/$id/analytics': typeof PortalsIdAnalyticsRoute
  '/portals/$id/api': typeof PortalsIdApiRoute
  '/portals/$id/build': typeof PortalsIdBuildRoute
  '/portals/$id/config': typeof PortalsIdConfigRoute
  '/portals/$id/keys': typeof PortalsIdKeysRoute
  '/portals/$id/overview': typeof PortalsIdOverviewRoute
  '/portals/$id/policies': typeof PortalsIdPoliciesRoute
  '/portals/$id/recommendations': typeof PortalsIdRecommendationsRoute
  '/portals/$id/search': typeof PortalsIdSearchRoute
  '/settings/catalog/completeness': typeof SettingsCatalogCompletenessRoute
  '/settings/catalog/enrichment': typeof SettingsCatalogEnrichmentRoute
  '/settings/catalog/groups': typeof SettingsCatalogGroupsRoute
  '/settings/catalog/migration': typeof SettingsCatalogMigrationRoute
  '/settings/catalog/search': typeof SettingsCatalogSearchRoute
  '/settings/catalog/synonyms': typeof SettingsCatalogSynonymsRoute
  '/settings/eval-datasets/$id': typeof SettingsEvalDatasetsIdRoute
  '/settings/export-templates/$id': typeof SettingsExportTemplatesIdRoute
  '/settings/plugins/$pluginId': typeof SettingsPluginsPluginIdRoute
  '/settings/plugins/developer': typeof SettingsPluginsDeveloperRoute
  '/settings/plugins/marketplace': typeof SettingsPluginsMarketplaceRoute
  '/settings/subscription/billing': typeof SettingsSubscriptionBillingRoute
  '/accounting/journal': typeof AccountingJournalIndexRoute
  '/admin/eval': typeof AdminEvalIndexRoute
  '/admin/features': typeof AdminFeaturesIndexRoute
  '/admin/workspaces': typeof AdminWorkspacesIndexRoute
  '/catalog/products': typeof CatalogProductsIndexRoute
  '/commerce/orders': typeof CommerceOrdersIndexRoute
  '/commerce/quotes': typeof CommerceQuotesIndexRoute
  '/commerce/returns': typeof CommerceReturnsIndexRoute
  '/commerce/shipments': typeof CommerceShipmentsIndexRoute
  '/docs/phase1': typeof DocsPhase1IndexRoute
  '/docs/plugins': typeof DocsPluginsIndexRoute
  '/docs/portal': typeof DocsPortalIndexRoute
  '/settings/plugins': typeof SettingsPluginsIndexRoute
  '/settings/subscription': typeof SettingsSubscriptionIndexRoute
  '/admin/eval/datasets/$id': typeof AdminEvalDatasetsIdRoute
  '/admin/eval/runs/$id': typeof AdminEvalRunsIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/accounting': typeof AccountingRouteWithChildren
  '/activity': typeof ActivityRoute
  '/admin': typeof AdminRouteWithChildren
  '/advisor': typeof AdvisorRouteWithChildren
  '/assistant': typeof AssistantRouteWithChildren
  '/background-jobs': typeof BackgroundJobsRouteWithChildren
  '/catalog': typeof CatalogRouteWithChildren
  '/commerce': typeof CommerceRouteWithChildren
  '/device': typeof DeviceRoute
  '/diagnostics': typeof DiagnosticsRouteWithChildren
  '/docs': typeof DocsRouteWithChildren
  '/login': typeof LoginRoute
  '/manufacturing': typeof ManufacturingRouteWithChildren
  '/notifications': typeof NotificationsRoute
  '/onboarding': typeof OnboardingRoute
  '/orders': typeof OrdersRoute
  '/parties': typeof PartiesRouteWithChildren
  '/portals': typeof PortalsRouteWithChildren
  '/pricing': typeof PricingRoute
  '/products': typeof ProductsRoute
  '/quotes': typeof QuotesRoute
  '/settings': typeof SettingsRouteWithChildren
  '/widget': typeof WidgetRoute
  '/work-items': typeof WorkItemsRouteWithChildren
  '/accounting/accounts': typeof AccountingAccountsRouteWithChildren
  '/accounting/analysis': typeof AccountingAnalysisRoute
  '/accounting/assets': typeof AccountingAssetsRoute
  '/accounting/bank': typeof AccountingBankRouteWithChildren
  '/accounting/budget': typeof AccountingBudgetRoute
  '/accounting/close': typeof AccountingCloseRouteWithChildren
  '/accounting/consolidation': typeof AccountingConsolidationRoute
  '/accounting/counterparty-recon': typeof AccountingCounterpartyReconRoute
  '/accounting/crosstab': typeof AccountingCrosstabRoute
  '/accounting/operations': typeof AccountingOperationsRoute
  '/accounting/payables': typeof AccountingPayablesRoute
  '/accounting/quality-check': typeof AccountingQualityCheckRoute
  '/accounting/receivables': typeof AccountingReceivablesRoute
  '/accounting/recurring': typeof AccountingRecurringRoute
  '/accounting/schemas': typeof AccountingSchemasRoute
  '/accounting/statements': typeof AccountingStatementsRoute
  '/admin/audit': typeof AdminAuditRoute
  '/admin/billing': typeof AdminBillingRouteWithChildren
  '/admin/diagram': typeof AdminDiagramRoute
  '/admin/eval': typeof AdminEvalRouteWithChildren
  '/admin/features': typeof AdminFeaturesRouteWithChildren
  '/admin/users': typeof AdminUsersRoute
  '/advisor/$id': typeof AdvisorIdRoute
  '/assistant/$threadId': typeof AssistantThreadIdRoute
  '/assistant/memory': typeof AssistantMemoryRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/auth/mcp-callback': typeof AuthMcpCallbackRoute
  '/background-jobs/$id': typeof BackgroundJobsIdRoute
  '/catalog/categories': typeof CatalogCategoriesRoute
  '/catalog/products': typeof CatalogProductsRouteWithChildren
  '/commerce/analytics': typeof CommerceAnalyticsRoute
  '/commerce/delivery': typeof CommerceDeliveryRoute
  '/commerce/orders': typeof CommerceOrdersRouteWithChildren
  '/commerce/payments': typeof CommercePaymentsRoute
  '/commerce/portals': typeof CommercePortalsRoute
  '/commerce/pricelists': typeof CommercePricelistsRouteWithChildren
  '/commerce/pricing': typeof CommercePricingRoute
  '/commerce/promotions': typeof CommercePromotionsRoute
  '/commerce/quotes': typeof CommerceQuotesRouteWithChildren
  '/commerce/returns': typeof CommerceReturnsRouteWithChildren
  '/commerce/shipments': typeof CommerceShipmentsRouteWithChildren
  '/commerce/subscriptions': typeof CommerceSubscriptionsRoute
  '/diagnostics/activity': typeof DiagnosticsActivityRoute
  '/diagnostics/analytics': typeof DiagnosticsAnalyticsRoute
  '/diagnostics/devices': typeof DiagnosticsDevicesRoute
  '/diagnostics/exports': typeof DiagnosticsExportsRoute
  '/diagnostics/live': typeof DiagnosticsLiveRoute
  '/diagnostics/policies': typeof DiagnosticsPoliciesRoute
  '/diagnostics/sessions': typeof DiagnosticsSessionsRoute
  '/diagnostics/storage': typeof DiagnosticsStorageRoute
  '/docs/plugins': typeof DocsPluginsRouteWithChildren
  '/docs/portal': typeof DocsPortalRouteWithChildren
  '/invite/$token': typeof InviteTokenRoute
  '/knowledge-doc/$id': typeof KnowledgeDocIdRoute
  '/manufacturing/actions': typeof ManufacturingActionsRoute
  '/manufacturing/board': typeof ManufacturingBoardRoute
  '/manufacturing/exceptions': typeof ManufacturingExceptionsRoute
  '/manufacturing/production': typeof ManufacturingProductionRoute
  '/manufacturing/sop': typeof ManufacturingSopRoute
  '/parties/$id': typeof PartiesIdRoute
  '/portals/$id': typeof PortalsIdRouteWithChildren
  '/settings/agent-profiles': typeof SettingsAgentProfilesRoute
  '/settings/appearance': typeof SettingsAppearanceRoute
  '/settings/catalog': typeof SettingsCatalogRouteWithChildren
  '/settings/channels': typeof SettingsChannelsRoute
  '/settings/code-templates': typeof SettingsCodeTemplatesRoute
  '/settings/compliance': typeof SettingsComplianceRoute
  '/settings/diagram': typeof SettingsDiagramRoute
  '/settings/eval-datasets': typeof SettingsEvalDatasetsRouteWithChildren
  '/settings/export-templates': typeof SettingsExportTemplatesRouteWithChildren
  '/settings/general': typeof SettingsGeneralRoute
  '/settings/integrations': typeof SettingsIntegrationsRoute
  '/settings/knowledge': typeof SettingsKnowledgeRoute
  '/settings/members': typeof SettingsMembersRoute
  '/settings/metal': typeof SettingsMetalRoute
  '/settings/notifications': typeof SettingsNotificationsRoute
  '/settings/organization': typeof SettingsOrganizationRoute
  '/settings/plugins': typeof SettingsPluginsRouteWithChildren
  '/settings/profile': typeof SettingsProfileRoute
  '/settings/roles': typeof SettingsRolesRoute
  '/settings/service-accounts': typeof SettingsServiceAccountsRoute
  '/settings/subscription': typeof SettingsSubscriptionRouteWithChildren
  '/settings/suppliers': typeof SettingsSuppliersRoute
  '/settings/tags': typeof SettingsTagsRoute
  '/settings/team-email': typeof SettingsTeamEmailRoute
  '/settings/tokens': typeof SettingsTokensRoute
  '/settings/webhooks': typeof SettingsWebhooksRoute
  '/settings/work-items': typeof SettingsWorkItemsRoute
  '/work-items/$id': typeof WorkItemsIdRoute
  '/accounting/': typeof AccountingIndexRoute
  '/admin/': typeof AdminIndexRoute
  '/advisor/': typeof AdvisorIndexRoute
  '/assistant/': typeof AssistantIndexRoute
  '/background-jobs/': typeof BackgroundJobsIndexRoute
  '/catalog/': typeof CatalogIndexRoute
  '/commerce/': typeof CommerceIndexRoute
  '/diagnostics/': typeof DiagnosticsIndexRoute
  '/docs/': typeof DocsIndexRoute
  '/manufacturing/': typeof ManufacturingIndexRoute
  '/parties/': typeof PartiesIndexRoute
  '/portals/': typeof PortalsIndexRoute
  '/settings/': typeof SettingsIndexRoute
  '/work-items/': typeof WorkItemsIndexRoute
  '/accounting/accounts/$id': typeof AccountingAccountsIdRoute
  '/accounting/bank/$id': typeof AccountingBankIdRoute
  '/accounting/close/$periodId': typeof AccountingClosePeriodIdRoute
  '/accounting/journal/$id': typeof AccountingJournalIdRoute
  '/accounting/journal/new': typeof AccountingJournalNewRoute
  '/admin/billing/$id': typeof AdminBillingIdRoute
  '/admin/eval/compare': typeof AdminEvalCompareRoute
  '/admin/eval/datasets': typeof AdminEvalDatasetsRouteWithChildren
  '/admin/eval/runs': typeof AdminEvalRunsRouteWithChildren
  '/admin/features/$id': typeof AdminFeaturesIdRoute
  '/admin/invoices/$id': typeof AdminInvoicesIdRoute
  '/admin/workspaces/$id': typeof AdminWorkspacesIdRoute
  '/assistant/sessions/$id': typeof AssistantSessionsIdRoute
  '/catalog/import-reviews/$jobId': typeof CatalogImportReviewsJobIdRoute
  '/catalog/products/$id': typeof CatalogProductsIdRoute
  '/commerce/orders/$id': typeof CommerceOrdersIdRoute
  '/commerce/pricelists/$id': typeof CommercePricelistsIdRoute
  '/commerce/quotes/$id': typeof CommerceQuotesIdRoute
  '/commerce/quotes/new': typeof CommerceQuotesNewRoute
  '/commerce/returns/$id': typeof CommerceReturnsIdRoute
  '/commerce/shipments/$id': typeof CommerceShipmentsIdRoute
  '/diagnostics/session/$id': typeof DiagnosticsSessionIdRoute
  '/docs/phase1/admin': typeof DocsPhase1AdminRoute
  '/docs/phase1/procurement': typeof DocsPhase1ProcurementRoute
  '/docs/phase1/sales': typeof DocsPhase1SalesRoute
  '/docs/plugins/capabilities': typeof DocsPluginsCapabilitiesRoute
  '/docs/plugins/getting-started': typeof DocsPluginsGettingStartedRoute
  '/docs/plugins/publishing': typeof DocsPluginsPublishingRoute
  '/docs/plugins/sdk-reference': typeof DocsPluginsSdkReferenceRoute
  '/docs/portal/endpoints': typeof DocsPortalEndpointsRoute
  '/docs/portal/widget': typeof DocsPortalWidgetRoute
  '/manufacturing/products/$id': typeof ManufacturingProductsIdRoute
  '/portals/$id/analytics': typeof PortalsIdAnalyticsRoute
  '/portals/$id/api': typeof PortalsIdApiRoute
  '/portals/$id/build': typeof PortalsIdBuildRoute
  '/portals/$id/config': typeof PortalsIdConfigRoute
  '/portals/$id/keys': typeof PortalsIdKeysRoute
  '/portals/$id/overview': typeof PortalsIdOverviewRoute
  '/portals/$id/policies': typeof PortalsIdPoliciesRoute
  '/portals/$id/recommendations': typeof PortalsIdRecommendationsRoute
  '/portals/$id/search': typeof PortalsIdSearchRoute
  '/settings/catalog/completeness': typeof SettingsCatalogCompletenessRoute
  '/settings/catalog/enrichment': typeof SettingsCatalogEnrichmentRoute
  '/settings/catalog/groups': typeof SettingsCatalogGroupsRoute
  '/settings/catalog/migration': typeof SettingsCatalogMigrationRoute
  '/settings/catalog/search': typeof SettingsCatalogSearchRoute
  '/settings/catalog/synonyms': typeof SettingsCatalogSynonymsRoute
  '/settings/eval-datasets/$id': typeof SettingsEvalDatasetsIdRoute
  '/settings/export-templates/$id': typeof SettingsExportTemplatesIdRoute
  '/settings/plugins/$pluginId': typeof SettingsPluginsPluginIdRoute
  '/settings/plugins/developer': typeof SettingsPluginsDeveloperRoute
  '/settings/plugins/marketplace': typeof SettingsPluginsMarketplaceRoute
  '/settings/subscription/billing': typeof SettingsSubscriptionBillingRoute
  '/accounting/journal/': typeof AccountingJournalIndexRoute
  '/admin/eval/': typeof AdminEvalIndexRoute
  '/admin/features/': typeof AdminFeaturesIndexRoute
  '/admin/workspaces/': typeof AdminWorkspacesIndexRoute
  '/catalog/products/': typeof CatalogProductsIndexRoute
  '/commerce/orders/': typeof CommerceOrdersIndexRoute
  '/commerce/quotes/': typeof CommerceQuotesIndexRoute
  '/commerce/returns/': typeof CommerceReturnsIndexRoute
  '/commerce/shipments/': typeof CommerceShipmentsIndexRoute
  '/docs/phase1/': typeof DocsPhase1IndexRoute
  '/docs/plugins/': typeof DocsPluginsIndexRoute
  '/docs/portal/': typeof DocsPortalIndexRoute
  '/settings/plugins/': typeof SettingsPluginsIndexRoute
  '/settings/subscription/': typeof SettingsSubscriptionIndexRoute
  '/admin/eval/datasets/$id': typeof AdminEvalDatasetsIdRoute
  '/admin/eval/runs/$id': typeof AdminEvalRunsIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/accounting'
    | '/activity'
    | '/admin'
    | '/advisor'
    | '/assistant'
    | '/background-jobs'
    | '/catalog'
    | '/commerce'
    | '/device'
    | '/diagnostics'
    | '/docs'
    | '/login'
    | '/manufacturing'
    | '/notifications'
    | '/onboarding'
    | '/orders'
    | '/parties'
    | '/portals'
    | '/pricing'
    | '/products'
    | '/quotes'
    | '/settings'
    | '/widget'
    | '/work-items'
    | '/accounting/accounts'
    | '/accounting/analysis'
    | '/accounting/assets'
    | '/accounting/bank'
    | '/accounting/budget'
    | '/accounting/close'
    | '/accounting/consolidation'
    | '/accounting/counterparty-recon'
    | '/accounting/crosstab'
    | '/accounting/operations'
    | '/accounting/payables'
    | '/accounting/quality-check'
    | '/accounting/receivables'
    | '/accounting/recurring'
    | '/accounting/schemas'
    | '/accounting/statements'
    | '/admin/audit'
    | '/admin/billing'
    | '/admin/diagram'
    | '/admin/eval'
    | '/admin/features'
    | '/admin/users'
    | '/advisor/$id'
    | '/assistant/$threadId'
    | '/assistant/memory'
    | '/auth/callback'
    | '/auth/mcp-callback'
    | '/background-jobs/$id'
    | '/catalog/categories'
    | '/catalog/products'
    | '/commerce/analytics'
    | '/commerce/delivery'
    | '/commerce/orders'
    | '/commerce/payments'
    | '/commerce/portals'
    | '/commerce/pricelists'
    | '/commerce/pricing'
    | '/commerce/promotions'
    | '/commerce/quotes'
    | '/commerce/returns'
    | '/commerce/shipments'
    | '/commerce/subscriptions'
    | '/diagnostics/activity'
    | '/diagnostics/analytics'
    | '/diagnostics/devices'
    | '/diagnostics/exports'
    | '/diagnostics/live'
    | '/diagnostics/policies'
    | '/diagnostics/sessions'
    | '/diagnostics/storage'
    | '/docs/plugins'
    | '/docs/portal'
    | '/invite/$token'
    | '/knowledge-doc/$id'
    | '/manufacturing/actions'
    | '/manufacturing/board'
    | '/manufacturing/exceptions'
    | '/manufacturing/production'
    | '/manufacturing/sop'
    | '/parties/$id'
    | '/portals/$id'
    | '/settings/agent-profiles'
    | '/settings/appearance'
    | '/settings/catalog'
    | '/settings/channels'
    | '/settings/code-templates'
    | '/settings/compliance'
    | '/settings/diagram'
    | '/settings/eval-datasets'
    | '/settings/export-templates'
    | '/settings/general'
    | '/settings/integrations'
    | '/settings/knowledge'
    | '/settings/members'
    | '/settings/metal'
    | '/settings/notifications'
    | '/settings/organization'
    | '/settings/plugins'
    | '/settings/profile'
    | '/settings/roles'
    | '/settings/service-accounts'
    | '/settings/subscription'
    | '/settings/suppliers'
    | '/settings/tags'
    | '/settings/team-email'
    | '/settings/tokens'
    | '/settings/webhooks'
    | '/settings/work-items'
    | '/work-items/$id'
    | '/accounting/'
    | '/admin/'
    | '/advisor/'
    | '/assistant/'
    | '/background-jobs/'
    | '/catalog/'
    | '/commerce/'
    | '/diagnostics/'
    | '/docs/'
    | '/manufacturing/'
    | '/parties/'
    | '/portals/'
    | '/settings/'
    | '/work-items/'
    | '/accounting/accounts/$id'
    | '/accounting/bank/$id'
    | '/accounting/close/$periodId'
    | '/accounting/journal/$id'
    | '/accounting/journal/new'
    | '/admin/billing/$id'
    | '/admin/eval/compare'
    | '/admin/eval/datasets'
    | '/admin/eval/runs'
    | '/admin/features/$id'
    | '/admin/invoices/$id'
    | '/admin/workspaces/$id'
    | '/assistant/sessions/$id'
    | '/catalog/import-reviews/$jobId'
    | '/catalog/products/$id'
    | '/commerce/orders/$id'
    | '/commerce/pricelists/$id'
    | '/commerce/quotes/$id'
    | '/commerce/quotes/new'
    | '/commerce/returns/$id'
    | '/commerce/shipments/$id'
    | '/diagnostics/session/$id'
    | '/docs/phase1/admin'
    | '/docs/phase1/procurement'
    | '/docs/phase1/sales'
    | '/docs/plugins/capabilities'
    | '/docs/plugins/getting-started'
    | '/docs/plugins/publishing'
    | '/docs/plugins/sdk-reference'
    | '/docs/portal/endpoints'
    | '/docs/portal/widget'
    | '/manufacturing/products/$id'
    | '/portals/$id/analytics'
    | '/portals/$id/api'
    | '/portals/$id/build'
    | '/portals/$id/config'
    | '/portals/$id/keys'
    | '/portals/$id/overview'
    | '/portals/$id/policies'
    | '/portals/$id/recommendations'
    | '/portals/$id/search'
    | '/settings/catalog/completeness'
    | '/settings/catalog/enrichment'
    | '/settings/catalog/groups'
    | '/settings/catalog/migration'
    | '/settings/catalog/search'
    | '/settings/catalog/synonyms'
    | '/settings/eval-datasets/$id'
    | '/settings/export-templates/$id'
    | '/settings/plugins/$pluginId'
    | '/settings/plugins/developer'
    | '/settings/plugins/marketplace'
    | '/settings/subscription/billing'
    | '/accounting/journal/'
    | '/admin/eval/'
    | '/admin/features/'
    | '/admin/workspaces/'
    | '/catalog/products/'
    | '/commerce/orders/'
    | '/commerce/quotes/'
    | '/commerce/returns/'
    | '/commerce/shipments/'
    | '/docs/phase1/'
    | '/docs/plugins/'
    | '/docs/portal/'
    | '/settings/plugins/'
    | '/settings/subscription/'
    | '/admin/eval/datasets/$id'
    | '/admin/eval/runs/$id'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/activity'
    | '/device'
    | '/login'
    | '/notifications'
    | '/onboarding'
    | '/orders'
    | '/pricing'
    | '/products'
    | '/quotes'
    | '/widget'
    | '/accounting/accounts'
    | '/accounting/analysis'
    | '/accounting/assets'
    | '/accounting/bank'
    | '/accounting/budget'
    | '/accounting/close'
    | '/accounting/consolidation'
    | '/accounting/counterparty-recon'
    | '/accounting/crosstab'
    | '/accounting/operations'
    | '/accounting/payables'
    | '/accounting/quality-check'
    | '/accounting/receivables'
    | '/accounting/recurring'
    | '/accounting/schemas'
    | '/accounting/statements'
    | '/admin/audit'
    | '/admin/billing'
    | '/admin/diagram'
    | '/admin/users'
    | '/advisor/$id'
    | '/assistant/$threadId'
    | '/assistant/memory'
    | '/auth/callback'
    | '/auth/mcp-callback'
    | '/background-jobs/$id'
    | '/catalog/categories'
    | '/commerce/analytics'
    | '/commerce/delivery'
    | '/commerce/payments'
    | '/commerce/portals'
    | '/commerce/pricelists'
    | '/commerce/pricing'
    | '/commerce/promotions'
    | '/commerce/subscriptions'
    | '/diagnostics/activity'
    | '/diagnostics/analytics'
    | '/diagnostics/devices'
    | '/diagnostics/exports'
    | '/diagnostics/live'
    | '/diagnostics/policies'
    | '/diagnostics/sessions'
    | '/diagnostics/storage'
    | '/invite/$token'
    | '/knowledge-doc/$id'
    | '/manufacturing/actions'
    | '/manufacturing/board'
    | '/manufacturing/exceptions'
    | '/manufacturing/production'
    | '/manufacturing/sop'
    | '/parties/$id'
    | '/portals/$id'
    | '/settings/agent-profiles'
    | '/settings/appearance'
    | '/settings/catalog'
    | '/settings/channels'
    | '/settings/code-templates'
    | '/settings/compliance'
    | '/settings/diagram'
    | '/settings/eval-datasets'
    | '/settings/export-templates'
    | '/settings/general'
    | '/settings/integrations'
    | '/settings/knowledge'
    | '/settings/members'
    | '/settings/metal'
    | '/settings/notifications'
    | '/settings/organization'
    | '/settings/profile'
    | '/settings/roles'
    | '/settings/service-accounts'
    | '/settings/suppliers'
    | '/settings/tags'
    | '/settings/team-email'
    | '/settings/tokens'
    | '/settings/webhooks'
    | '/settings/work-items'
    | '/work-items/$id'
    | '/accounting'
    | '/admin'
    | '/advisor'
    | '/assistant'
    | '/background-jobs'
    | '/catalog'
    | '/commerce'
    | '/diagnostics'
    | '/docs'
    | '/manufacturing'
    | '/parties'
    | '/portals'
    | '/settings'
    | '/work-items'
    | '/accounting/accounts/$id'
    | '/accounting/bank/$id'
    | '/accounting/close/$periodId'
    | '/accounting/journal/$id'
    | '/accounting/journal/new'
    | '/admin/billing/$id'
    | '/admin/eval/compare'
    | '/admin/eval/datasets'
    | '/admin/eval/runs'
    | '/admin/features/$id'
    | '/admin/invoices/$id'
    | '/admin/workspaces/$id'
    | '/assistant/sessions/$id'
    | '/catalog/import-reviews/$jobId'
    | '/catalog/products/$id'
    | '/commerce/orders/$id'
    | '/commerce/pricelists/$id'
    | '/commerce/quotes/$id'
    | '/commerce/quotes/new'
    | '/commerce/returns/$id'
    | '/commerce/shipments/$id'
    | '/diagnostics/session/$id'
    | '/docs/phase1/admin'
    | '/docs/phase1/procurement'
    | '/docs/phase1/sales'
    | '/docs/plugins/capabilities'
    | '/docs/plugins/getting-started'
    | '/docs/plugins/publishing'
    | '/docs/plugins/sdk-reference'
    | '/docs/portal/endpoints'
    | '/docs/portal/widget'
    | '/manufacturing/products/$id'
    | '/portals/$id/analytics'
    | '/portals/$id/api'
    | '/portals/$id/build'
    | '/portals/$id/config'
    | '/portals/$id/keys'
    | '/portals/$id/overview'
    | '/portals/$id/policies'
    | '/portals/$id/recommendations'
    | '/portals/$id/search'
    | '/settings/catalog/completeness'
    | '/settings/catalog/enrichment'
    | '/settings/catalog/groups'
    | '/settings/catalog/migration'
    | '/settings/catalog/search'
    | '/settings/catalog/synonyms'
    | '/settings/eval-datasets/$id'
    | '/settings/export-templates/$id'
    | '/settings/plugins/$pluginId'
    | '/settings/plugins/developer'
    | '/settings/plugins/marketplace'
    | '/settings/subscription/billing'
    | '/accounting/journal'
    | '/admin/eval'
    | '/admin/features'
    | '/admin/workspaces'
    | '/catalog/products'
    | '/commerce/orders'
    | '/commerce/quotes'
    | '/commerce/returns'
    | '/commerce/shipments'
    | '/docs/phase1'
    | '/docs/plugins'
    | '/docs/portal'
    | '/settings/plugins'
    | '/settings/subscription'
    | '/admin/eval/datasets/$id'
    | '/admin/eval/runs/$id'
  id:
    | '__root__'
    | '/'
    | '/accounting'
    | '/activity'
    | '/admin'
    | '/advisor'
    | '/assistant'
    | '/background-jobs'
    | '/catalog'
    | '/commerce'
    | '/device'
    | '/diagnostics'
    | '/docs'
    | '/login'
    | '/manufacturing'
    | '/notifications'
    | '/onboarding'
    | '/orders'
    | '/parties'
    | '/portals'
    | '/pricing'
    | '/products'
    | '/quotes'
    | '/settings'
    | '/widget'
    | '/work-items'
    | '/accounting/accounts'
    | '/accounting/analysis'
    | '/accounting/assets'
    | '/accounting/bank'
    | '/accounting/budget'
    | '/accounting/close'
    | '/accounting/consolidation'
    | '/accounting/counterparty-recon'
    | '/accounting/crosstab'
    | '/accounting/operations'
    | '/accounting/payables'
    | '/accounting/quality-check'
    | '/accounting/receivables'
    | '/accounting/recurring'
    | '/accounting/schemas'
    | '/accounting/statements'
    | '/admin/audit'
    | '/admin/billing'
    | '/admin/diagram'
    | '/admin/eval'
    | '/admin/features'
    | '/admin/users'
    | '/advisor/$id'
    | '/assistant/$threadId'
    | '/assistant/memory'
    | '/auth/callback'
    | '/auth/mcp-callback'
    | '/background-jobs/$id'
    | '/catalog/categories'
    | '/catalog/products'
    | '/commerce/analytics'
    | '/commerce/delivery'
    | '/commerce/orders'
    | '/commerce/payments'
    | '/commerce/portals'
    | '/commerce/pricelists'
    | '/commerce/pricing'
    | '/commerce/promotions'
    | '/commerce/quotes'
    | '/commerce/returns'
    | '/commerce/shipments'
    | '/commerce/subscriptions'
    | '/diagnostics/activity'
    | '/diagnostics/analytics'
    | '/diagnostics/devices'
    | '/diagnostics/exports'
    | '/diagnostics/live'
    | '/diagnostics/policies'
    | '/diagnostics/sessions'
    | '/diagnostics/storage'
    | '/docs/plugins'
    | '/docs/portal'
    | '/invite/$token'
    | '/knowledge-doc/$id'
    | '/manufacturing/actions'
    | '/manufacturing/board'
    | '/manufacturing/exceptions'
    | '/manufacturing/production'
    | '/manufacturing/sop'
    | '/parties/$id'
    | '/portals/$id'
    | '/settings/agent-profiles'
    | '/settings/appearance'
    | '/settings/catalog'
    | '/settings/channels'
    | '/settings/code-templates'
    | '/settings/compliance'
    | '/settings/diagram'
    | '/settings/eval-datasets'
    | '/settings/export-templates'
    | '/settings/general'
    | '/settings/integrations'
    | '/settings/knowledge'
    | '/settings/members'
    | '/settings/metal'
    | '/settings/notifications'
    | '/settings/organization'
    | '/settings/plugins'
    | '/settings/profile'
    | '/settings/roles'
    | '/settings/service-accounts'
    | '/settings/subscription'
    | '/settings/suppliers'
    | '/settings/tags'
    | '/settings/team-email'
    | '/settings/tokens'
    | '/settings/webhooks'
    | '/settings/work-items'
    | '/work-items/$id'
    | '/accounting/'
    | '/admin/'
    | '/advisor/'
    | '/assistant/'
    | '/background-jobs/'
    | '/catalog/'
    | '/commerce/'
    | '/diagnostics/'
    | '/docs/'
    | '/manufacturing/'
    | '/parties/'
    | '/portals/'
    | '/settings/'
    | '/work-items/'
    | '/accounting/accounts/$id'
    | '/accounting/bank/$id'
    | '/accounting/close/$periodId'
    | '/accounting/journal/$id'
    | '/accounting/journal/new'
    | '/admin/billing/$id'
    | '/admin/eval/compare'
    | '/admin/eval/datasets'
    | '/admin/eval/runs'
    | '/admin/features/$id'
    | '/admin/invoices/$id'
    | '/admin/workspaces/$id'
    | '/assistant/sessions/$id'
    | '/catalog/import-reviews/$jobId'
    | '/catalog/products/$id'
    | '/commerce/orders/$id'
    | '/commerce/pricelists/$id'
    | '/commerce/quotes/$id'
    | '/commerce/quotes/new'
    | '/commerce/returns/$id'
    | '/commerce/shipments/$id'
    | '/diagnostics/session/$id'
    | '/docs/phase1/admin'
    | '/docs/phase1/procurement'
    | '/docs/phase1/sales'
    | '/docs/plugins/capabilities'
    | '/docs/plugins/getting-started'
    | '/docs/plugins/publishing'
    | '/docs/plugins/sdk-reference'
    | '/docs/portal/endpoints'
    | '/docs/portal/widget'
    | '/manufacturing/products/$id'
    | '/portals/$id/analytics'
    | '/portals/$id/api'
    | '/portals/$id/build'
    | '/portals/$id/config'
    | '/portals/$id/keys'
    | '/portals/$id/overview'
    | '/portals/$id/policies'
    | '/portals/$id/recommendations'
    | '/portals/$id/search'
    | '/settings/catalog/completeness'
    | '/settings/catalog/enrichment'
    | '/settings/catalog/groups'
    | '/settings/catalog/migration'
    | '/settings/catalog/search'
    | '/settings/catalog/synonyms'
    | '/settings/eval-datasets/$id'
    | '/settings/export-templates/$id'
    | '/settings/plugins/$pluginId'
    | '/settings/plugins/developer'
    | '/settings/plugins/marketplace'
    | '/settings/subscription/billing'
    | '/accounting/journal/'
    | '/admin/eval/'
    | '/admin/features/'
    | '/admin/workspaces/'
    | '/catalog/products/'
    | '/commerce/orders/'
    | '/commerce/quotes/'
    | '/commerce/returns/'
    | '/commerce/shipments/'
    | '/docs/phase1/'
    | '/docs/plugins/'
    | '/docs/portal/'
    | '/settings/plugins/'
    | '/settings/subscription/'
    | '/admin/eval/datasets/$id'
    | '/admin/eval/runs/$id'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AccountingRoute: typeof AccountingRouteWithChildren
  ActivityRoute: typeof ActivityRoute
  AdminRoute: typeof AdminRouteWithChildren
  AdvisorRoute: typeof AdvisorRouteWithChildren
  AssistantRoute: typeof AssistantRouteWithChildren
  BackgroundJobsRoute: typeof BackgroundJobsRouteWithChildren
  CatalogRoute: typeof CatalogRouteWithChildren
  CommerceRoute: typeof CommerceRouteWithChildren
  DeviceRoute: typeof DeviceRoute
  DiagnosticsRoute: typeof DiagnosticsRouteWithChildren
  DocsRoute: typeof DocsRouteWithChildren
  LoginRoute: typeof LoginRoute
  ManufacturingRoute: typeof ManufacturingRouteWithChildren
  NotificationsRoute: typeof NotificationsRoute
  OnboardingRoute: typeof OnboardingRoute
  OrdersRoute: typeof OrdersRoute
  PartiesRoute: typeof PartiesRouteWithChildren
  PortalsRoute: typeof PortalsRouteWithChildren
  PricingRoute: typeof PricingRoute
  ProductsRoute: typeof ProductsRoute
  QuotesRoute: typeof QuotesRoute
  SettingsRoute: typeof SettingsRouteWithChildren
  WidgetRoute: typeof WidgetRoute
  WorkItemsRoute: typeof WorkItemsRouteWithChildren
  AuthCallbackRoute: typeof AuthCallbackRoute
  AuthMcpCallbackRoute: typeof AuthMcpCallbackRoute
  InviteTokenRoute: typeof InviteTokenRoute
  KnowledgeDocIdRoute: typeof KnowledgeDocIdRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/work-items': {
      id: '/work-items'
      path: '/work-items'
      fullPath: '/work-items'
      preLoaderRoute: typeof WorkItemsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/widget': {
      id: '/widget'
      path: '/widget'
      fullPath: '/widget'
      preLoaderRoute: typeof WidgetRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings': {
      id: '/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/quotes': {
      id: '/quotes'
      path: '/quotes'
      fullPath: '/quotes'
      preLoaderRoute: typeof QuotesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/products': {
      id: '/products'
      path: '/products'
      fullPath: '/products'
      preLoaderRoute: typeof ProductsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/pricing': {
      id: '/pricing'
      path: '/pricing'
      fullPath: '/pricing'
      preLoaderRoute: typeof PricingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/portals': {
      id: '/portals'
      path: '/portals'
      fullPath: '/portals'
      preLoaderRoute: typeof PortalsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/parties': {
      id: '/parties'
      path: '/parties'
      fullPath: '/parties'
      preLoaderRoute: typeof PartiesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/orders': {
      id: '/orders'
      path: '/orders'
      fullPath: '/orders'
      preLoaderRoute: typeof OrdersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding': {
      id: '/onboarding'
      path: '/onboarding'
      fullPath: '/onboarding'
      preLoaderRoute: typeof OnboardingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/notifications': {
      id: '/notifications'
      path: '/notifications'
      fullPath: '/notifications'
      preLoaderRoute: typeof NotificationsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/manufacturing': {
      id: '/manufacturing'
      path: '/manufacturing'
      fullPath: '/manufacturing'
      preLoaderRoute: typeof ManufacturingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/docs': {
      id: '/docs'
      path: '/docs'
      fullPath: '/docs'
      preLoaderRoute: typeof DocsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/diagnostics': {
      id: '/diagnostics'
      path: '/diagnostics'
      fullPath: '/diagnostics'
      preLoaderRoute: typeof DiagnosticsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/device': {
      id: '/device'
      path: '/device'
      fullPath: '/device'
      preLoaderRoute: typeof DeviceRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/commerce': {
      id: '/commerce'
      path: '/commerce'
      fullPath: '/commerce'
      preLoaderRoute: typeof CommerceRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/catalog': {
      id: '/catalog'
      path: '/catalog'
      fullPath: '/catalog'
      preLoaderRoute: typeof CatalogRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/background-jobs': {
      id: '/background-jobs'
      path: '/background-jobs'
      fullPath: '/background-jobs'
      preLoaderRoute: typeof BackgroundJobsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/assistant': {
      id: '/assistant'
      path: '/assistant'
      fullPath: '/assistant'
      preLoaderRoute: typeof AssistantRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/advisor': {
      id: '/advisor'
      path: '/advisor'
      fullPath: '/advisor'
      preLoaderRoute: typeof AdvisorRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin': {
      id: '/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/activity': {
      id: '/activity'
      path: '/activity'
      fullPath: '/activity'
      preLoaderRoute: typeof ActivityRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/accounting': {
      id: '/accounting'
      path: '/accounting'
      fullPath: '/accounting'
      preLoaderRoute: typeof AccountingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/work-items/': {
      id: '/work-items/'
      path: '/'
      fullPath: '/work-items/'
      preLoaderRoute: typeof WorkItemsIndexRouteImport
      parentRoute: typeof WorkItemsRoute
    }
    '/settings/': {
      id: '/settings/'
      path: '/'
      fullPath: '/settings/'
      preLoaderRoute: typeof SettingsIndexRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/portals/': {
      id: '/portals/'
      path: '/'
      fullPath: '/portals/'
      preLoaderRoute: typeof PortalsIndexRouteImport
      parentRoute: typeof PortalsRoute
    }
    '/parties/': {
      id: '/parties/'
      path: '/'
      fullPath: '/parties/'
      preLoaderRoute: typeof PartiesIndexRouteImport
      parentRoute: typeof PartiesRoute
    }
    '/manufacturing/': {
      id: '/manufacturing/'
      path: '/'
      fullPath: '/manufacturing/'
      preLoaderRoute: typeof ManufacturingIndexRouteImport
      parentRoute: typeof ManufacturingRoute
    }
    '/docs/': {
      id: '/docs/'
      path: '/'
      fullPath: '/docs/'
      preLoaderRoute: typeof DocsIndexRouteImport
      parentRoute: typeof DocsRoute
    }
    '/diagnostics/': {
      id: '/diagnostics/'
      path: '/'
      fullPath: '/diagnostics/'
      preLoaderRoute: typeof DiagnosticsIndexRouteImport
      parentRoute: typeof DiagnosticsRoute
    }
    '/commerce/': {
      id: '/commerce/'
      path: '/'
      fullPath: '/commerce/'
      preLoaderRoute: typeof CommerceIndexRouteImport
      parentRoute: typeof CommerceRoute
    }
    '/catalog/': {
      id: '/catalog/'
      path: '/'
      fullPath: '/catalog/'
      preLoaderRoute: typeof CatalogIndexRouteImport
      parentRoute: typeof CatalogRoute
    }
    '/background-jobs/': {
      id: '/background-jobs/'
      path: '/'
      fullPath: '/background-jobs/'
      preLoaderRoute: typeof BackgroundJobsIndexRouteImport
      parentRoute: typeof BackgroundJobsRoute
    }
    '/assistant/': {
      id: '/assistant/'
      path: '/'
      fullPath: '/assistant/'
      preLoaderRoute: typeof AssistantIndexRouteImport
      parentRoute: typeof AssistantRoute
    }
    '/advisor/': {
      id: '/advisor/'
      path: '/'
      fullPath: '/advisor/'
      preLoaderRoute: typeof AdvisorIndexRouteImport
      parentRoute: typeof AdvisorRoute
    }
    '/admin/': {
      id: '/admin/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof AdminIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/accounting/': {
      id: '/accounting/'
      path: '/'
      fullPath: '/accounting/'
      preLoaderRoute: typeof AccountingIndexRouteImport
      parentRoute: typeof AccountingRoute
    }
    '/work-items/$id': {
      id: '/work-items/$id'
      path: '/$id'
      fullPath: '/work-items/$id'
      preLoaderRoute: typeof WorkItemsIdRouteImport
      parentRoute: typeof WorkItemsRoute
    }
    '/settings/work-items': {
      id: '/settings/work-items'
      path: '/work-items'
      fullPath: '/settings/work-items'
      preLoaderRoute: typeof SettingsWorkItemsRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/webhooks': {
      id: '/settings/webhooks'
      path: '/webhooks'
      fullPath: '/settings/webhooks'
      preLoaderRoute: typeof SettingsWebhooksRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/tokens': {
      id: '/settings/tokens'
      path: '/tokens'
      fullPath: '/settings/tokens'
      preLoaderRoute: typeof SettingsTokensRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/team-email': {
      id: '/settings/team-email'
      path: '/team-email'
      fullPath: '/settings/team-email'
      preLoaderRoute: typeof SettingsTeamEmailRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/tags': {
      id: '/settings/tags'
      path: '/tags'
      fullPath: '/settings/tags'
      preLoaderRoute: typeof SettingsTagsRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/suppliers': {
      id: '/settings/suppliers'
      path: '/suppliers'
      fullPath: '/settings/suppliers'
      preLoaderRoute: typeof SettingsSuppliersRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/subscription': {
      id: '/settings/subscription'
      path: '/subscription'
      fullPath: '/settings/subscription'
      preLoaderRoute: typeof SettingsSubscriptionRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/service-accounts': {
      id: '/settings/service-accounts'
      path: '/service-accounts'
      fullPath: '/settings/service-accounts'
      preLoaderRoute: typeof SettingsServiceAccountsRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/roles': {
      id: '/settings/roles'
      path: '/roles'
      fullPath: '/settings/roles'
      preLoaderRoute: typeof SettingsRolesRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/profile': {
      id: '/settings/profile'
      path: '/profile'
      fullPath: '/settings/profile'
      preLoaderRoute: typeof SettingsProfileRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/plugins': {
      id: '/settings/plugins'
      path: '/plugins'
      fullPath: '/settings/plugins'
      preLoaderRoute: typeof SettingsPluginsRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/organization': {
      id: '/settings/organization'
      path: '/organization'
      fullPath: '/settings/organization'
      preLoaderRoute: typeof SettingsOrganizationRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/notifications': {
      id: '/settings/notifications'
      path: '/notifications'
      fullPath: '/settings/notifications'
      preLoaderRoute: typeof SettingsNotificationsRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/metal': {
      id: '/settings/metal'
      path: '/metal'
      fullPath: '/settings/metal'
      preLoaderRoute: typeof SettingsMetalRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/members': {
      id: '/settings/members'
      path: '/members'
      fullPath: '/settings/members'
      preLoaderRoute: typeof SettingsMembersRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/knowledge': {
      id: '/settings/knowledge'
      path: '/knowledge'
      fullPath: '/settings/knowledge'
      preLoaderRoute: typeof SettingsKnowledgeRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/integrations': {
      id: '/settings/integrations'
      path: '/integrations'
      fullPath: '/settings/integrations'
      preLoaderRoute: typeof SettingsIntegrationsRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/general': {
      id: '/settings/general'
      path: '/general'
      fullPath: '/settings/general'
      preLoaderRoute: typeof SettingsGeneralRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/export-templates': {
      id: '/settings/export-templates'
      path: '/export-templates'
      fullPath: '/settings/export-templates'
      preLoaderRoute: typeof SettingsExportTemplatesRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/eval-datasets': {
      id: '/settings/eval-datasets'
      path: '/eval-datasets'
      fullPath: '/settings/eval-datasets'
      preLoaderRoute: typeof SettingsEvalDatasetsRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/diagram': {
      id: '/settings/diagram'
      path: '/diagram'
      fullPath: '/settings/diagram'
      preLoaderRoute: typeof SettingsDiagramRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/compliance': {
      id: '/settings/compliance'
      path: '/compliance'
      fullPath: '/settings/compliance'
      preLoaderRoute: typeof SettingsComplianceRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/code-templates': {
      id: '/settings/code-templates'
      path: '/code-templates'
      fullPath: '/settings/code-templates'
      preLoaderRoute: typeof SettingsCodeTemplatesRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/channels': {
      id: '/settings/channels'
      path: '/channels'
      fullPath: '/settings/channels'
      preLoaderRoute: typeof SettingsChannelsRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/catalog': {
      id: '/settings/catalog'
      path: '/catalog'
      fullPath: '/settings/catalog'
      preLoaderRoute: typeof SettingsCatalogRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/appearance': {
      id: '/settings/appearance'
      path: '/appearance'
      fullPath: '/settings/appearance'
      preLoaderRoute: typeof SettingsAppearanceRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/agent-profiles': {
      id: '/settings/agent-profiles'
      path: '/agent-profiles'
      fullPath: '/settings/agent-profiles'
      preLoaderRoute: typeof SettingsAgentProfilesRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/portals/$id': {
      id: '/portals/$id'
      path: '/$id'
      fullPath: '/portals/$id'
      preLoaderRoute: typeof PortalsIdRouteImport
      parentRoute: typeof PortalsRoute
    }
    '/parties/$id': {
      id: '/parties/$id'
      path: '/$id'
      fullPath: '/parties/$id'
      preLoaderRoute: typeof PartiesIdRouteImport
      parentRoute: typeof PartiesRoute
    }
    '/manufacturing/sop': {
      id: '/manufacturing/sop'
      path: '/sop'
      fullPath: '/manufacturing/sop'
      preLoaderRoute: typeof ManufacturingSopRouteImport
      parentRoute: typeof ManufacturingRoute
    }
    '/manufacturing/production': {
      id: '/manufacturing/production'
      path: '/production'
      fullPath: '/manufacturing/production'
      preLoaderRoute: typeof ManufacturingProductionRouteImport
      parentRoute: typeof ManufacturingRoute
    }
    '/manufacturing/exceptions': {
      id: '/manufacturing/exceptions'
      path: '/exceptions'
      fullPath: '/manufacturing/exceptions'
      preLoaderRoute: typeof ManufacturingExceptionsRouteImport
      parentRoute: typeof ManufacturingRoute
    }
    '/manufacturing/board': {
      id: '/manufacturing/board'
      path: '/board'
      fullPath: '/manufacturing/board'
      preLoaderRoute: typeof ManufacturingBoardRouteImport
      parentRoute: typeof ManufacturingRoute
    }
    '/manufacturing/actions': {
      id: '/manufacturing/actions'
      path: '/actions'
      fullPath: '/manufacturing/actions'
      preLoaderRoute: typeof ManufacturingActionsRouteImport
      parentRoute: typeof ManufacturingRoute
    }
    '/knowledge-doc/$id': {
      id: '/knowledge-doc/$id'
      path: '/knowledge-doc/$id'
      fullPath: '/knowledge-doc/$id'
      preLoaderRoute: typeof KnowledgeDocIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/invite/$token': {
      id: '/invite/$token'
      path: '/invite/$token'
      fullPath: '/invite/$token'
      preLoaderRoute: typeof InviteTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/docs/portal': {
      id: '/docs/portal'
      path: '/portal'
      fullPath: '/docs/portal'
      preLoaderRoute: typeof DocsPortalRouteImport
      parentRoute: typeof DocsRoute
    }
    '/docs/plugins': {
      id: '/docs/plugins'
      path: '/plugins'
      fullPath: '/docs/plugins'
      preLoaderRoute: typeof DocsPluginsRouteImport
      parentRoute: typeof DocsRoute
    }
    '/diagnostics/storage': {
      id: '/diagnostics/storage'
      path: '/storage'
      fullPath: '/diagnostics/storage'
      preLoaderRoute: typeof DiagnosticsStorageRouteImport
      parentRoute: typeof DiagnosticsRoute
    }
    '/diagnostics/sessions': {
      id: '/diagnostics/sessions'
      path: '/sessions'
      fullPath: '/diagnostics/sessions'
      preLoaderRoute: typeof DiagnosticsSessionsRouteImport
      parentRoute: typeof DiagnosticsRoute
    }
    '/diagnostics/policies': {
      id: '/diagnostics/policies'
      path: '/policies'
      fullPath: '/diagnostics/policies'
      preLoaderRoute: typeof DiagnosticsPoliciesRouteImport
      parentRoute: typeof DiagnosticsRoute
    }
    '/diagnostics/live': {
      id: '/diagnostics/live'
      path: '/live'
      fullPath: '/diagnostics/live'
      preLoaderRoute: typeof DiagnosticsLiveRouteImport
      parentRoute: typeof DiagnosticsRoute
    }
    '/diagnostics/exports': {
      id: '/diagnostics/exports'
      path: '/exports'
      fullPath: '/diagnostics/exports'
      preLoaderRoute: typeof DiagnosticsExportsRouteImport
      parentRoute: typeof DiagnosticsRoute
    }
    '/diagnostics/devices': {
      id: '/diagnostics/devices'
      path: '/devices'
      fullPath: '/diagnostics/devices'
      preLoaderRoute: typeof DiagnosticsDevicesRouteImport
      parentRoute: typeof DiagnosticsRoute
    }
    '/diagnostics/analytics': {
      id: '/diagnostics/analytics'
      path: '/analytics'
      fullPath: '/diagnostics/analytics'
      preLoaderRoute: typeof DiagnosticsAnalyticsRouteImport
      parentRoute: typeof DiagnosticsRoute
    }
    '/diagnostics/activity': {
      id: '/diagnostics/activity'
      path: '/activity'
      fullPath: '/diagnostics/activity'
      preLoaderRoute: typeof DiagnosticsActivityRouteImport
      parentRoute: typeof DiagnosticsRoute
    }
    '/commerce/subscriptions': {
      id: '/commerce/subscriptions'
      path: '/subscriptions'
      fullPath: '/commerce/subscriptions'
      preLoaderRoute: typeof CommerceSubscriptionsRouteImport
      parentRoute: typeof CommerceRoute
    }
    '/commerce/shipments': {
      id: '/commerce/shipments'
      path: '/shipments'
      fullPath: '/commerce/shipments'
      preLoaderRoute: typeof CommerceShipmentsRouteImport
      parentRoute: typeof CommerceRoute
    }
    '/commerce/returns': {
      id: '/commerce/returns'
      path: '/returns'
      fullPath: '/commerce/returns'
      preLoaderRoute: typeof CommerceReturnsRouteImport
      parentRoute: typeof CommerceRoute
    }
    '/commerce/quotes': {
      id: '/commerce/quotes'
      path: '/quotes'
      fullPath: '/commerce/quotes'
      preLoaderRoute: typeof CommerceQuotesRouteImport
      parentRoute: typeof CommerceRoute
    }
    '/commerce/promotions': {
      id: '/commerce/promotions'
      path: '/promotions'
      fullPath: '/commerce/promotions'
      preLoaderRoute: typeof CommercePromotionsRouteImport
      parentRoute: typeof CommerceRoute
    }
    '/commerce/pricing': {
      id: '/commerce/pricing'
      path: '/pricing'
      fullPath: '/commerce/pricing'
      preLoaderRoute: typeof CommercePricingRouteImport
      parentRoute: typeof CommerceRoute
    }
    '/commerce/pricelists': {
      id: '/commerce/pricelists'
      path: '/pricelists'
      fullPath: '/commerce/pricelists'
      preLoaderRoute: typeof CommercePricelistsRouteImport
      parentRoute: typeof CommerceRoute
    }
    '/commerce/portals': {
      id: '/commerce/portals'
      path: '/portals'
      fullPath: '/commerce/portals'
      preLoaderRoute: typeof CommercePortalsRouteImport
      parentRoute: typeof CommerceRoute
    }
    '/commerce/payments': {
      id: '/commerce/payments'
      path: '/payments'
      fullPath: '/commerce/payments'
      preLoaderRoute: typeof CommercePaymentsRouteImport
      parentRoute: typeof CommerceRoute
    }
    '/commerce/orders': {
      id: '/commerce/orders'
      path: '/orders'
      fullPath: '/commerce/orders'
      preLoaderRoute: typeof CommerceOrdersRouteImport
      parentRoute: typeof CommerceRoute
    }
    '/commerce/delivery': {
      id: '/commerce/delivery'
      path: '/delivery'
      fullPath: '/commerce/delivery'
      preLoaderRoute: typeof CommerceDeliveryRouteImport
      parentRoute: typeof CommerceRoute
    }
    '/commerce/analytics': {
      id: '/commerce/analytics'
      path: '/analytics'
      fullPath: '/commerce/analytics'
      preLoaderRoute: typeof CommerceAnalyticsRouteImport
      parentRoute: typeof CommerceRoute
    }
    '/catalog/products': {
      id: '/catalog/products'
      path: '/products'
      fullPath: '/catalog/products'
      preLoaderRoute: typeof CatalogProductsRouteImport
      parentRoute: typeof CatalogRoute
    }
    '/catalog/categories': {
      id: '/catalog/categories'
      path: '/categories'
      fullPath: '/catalog/categories'
      preLoaderRoute: typeof CatalogCategoriesRouteImport
      parentRoute: typeof CatalogRoute
    }
    '/background-jobs/$id': {
      id: '/background-jobs/$id'
      path: '/$id'
      fullPath: '/background-jobs/$id'
      preLoaderRoute: typeof BackgroundJobsIdRouteImport
      parentRoute: typeof BackgroundJobsRoute
    }
    '/auth/mcp-callback': {
      id: '/auth/mcp-callback'
      path: '/auth/mcp-callback'
      fullPath: '/auth/mcp-callback'
      preLoaderRoute: typeof AuthMcpCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/callback': {
      id: '/auth/callback'
      path: '/auth/callback'
      fullPath: '/auth/callback'
      preLoaderRoute: typeof AuthCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/assistant/memory': {
      id: '/assistant/memory'
      path: '/memory'
      fullPath: '/assistant/memory'
      preLoaderRoute: typeof AssistantMemoryRouteImport
      parentRoute: typeof AssistantRoute
    }
    '/assistant/$threadId': {
      id: '/assistant/$threadId'
      path: '/$threadId'
      fullPath: '/assistant/$threadId'
      preLoaderRoute: typeof AssistantThreadIdRouteImport
      parentRoute: typeof AssistantRoute
    }
    '/advisor/$id': {
      id: '/advisor/$id'
      path: '/$id'
      fullPath: '/advisor/$id'
      preLoaderRoute: typeof AdvisorIdRouteImport
      parentRoute: typeof AdvisorRoute
    }
    '/admin/users': {
      id: '/admin/users'
      path: '/users'
      fullPath: '/admin/users'
      preLoaderRoute: typeof AdminUsersRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/features': {
      id: '/admin/features'
      path: '/features'
      fullPath: '/admin/features'
      preLoaderRoute: typeof AdminFeaturesRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/eval': {
      id: '/admin/eval'
      path: '/eval'
      fullPath: '/admin/eval'
      preLoaderRoute: typeof AdminEvalRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/diagram': {
      id: '/admin/diagram'
      path: '/diagram'
      fullPath: '/admin/diagram'
      preLoaderRoute: typeof AdminDiagramRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/billing': {
      id: '/admin/billing'
      path: '/billing'
      fullPath: '/admin/billing'
      preLoaderRoute: typeof AdminBillingRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/audit': {
      id: '/admin/audit'
      path: '/audit'
      fullPath: '/admin/audit'
      preLoaderRoute: typeof AdminAuditRouteImport
      parentRoute: typeof AdminRoute
    }
    '/accounting/statements': {
      id: '/accounting/statements'
      path: '/statements'
      fullPath: '/accounting/statements'
      preLoaderRoute: typeof AccountingStatementsRouteImport
      parentRoute: typeof AccountingRoute
    }
    '/accounting/schemas': {
      id: '/accounting/schemas'
      path: '/schemas'
      fullPath: '/accounting/schemas'
      preLoaderRoute: typeof AccountingSchemasRouteImport
      parentRoute: typeof AccountingRoute
    }
    '/accounting/recurring': {
      id: '/accounting/recurring'
      path: '/recurring'
      fullPath: '/accounting/recurring'
      preLoaderRoute: typeof AccountingRecurringRouteImport
      parentRoute: typeof AccountingRoute
    }
    '/accounting/receivables': {
      id: '/accounting/receivables'
      path: '/receivables'
      fullPath: '/accounting/receivables'
      preLoaderRoute: typeof AccountingReceivablesRouteImport
      parentRoute: typeof AccountingRoute
    }
    '/accounting/quality-check': {
      id: '/accounting/quality-check'
      path: '/quality-check'
      fullPath: '/accounting/quality-check'
      preLoaderRoute: typeof AccountingQualityCheckRouteImport
      parentRoute: typeof AccountingRoute
    }
    '/accounting/payables': {
      id: '/accounting/payables'
      path: '/payables'
      fullPath: '/accounting/payables'
      preLoaderRoute: typeof AccountingPayablesRouteImport
      parentRoute: typeof AccountingRoute
    }
    '/accounting/operations': {
      id: '/accounting/operations'
      path: '/operations'
      fullPath: '/accounting/operations'
      preLoaderRoute: typeof AccountingOperationsRouteImport
      parentRoute: typeof AccountingRoute
    }
    '/accounting/crosstab': {
      id: '/accounting/crosstab'
      path: '/crosstab'
      fullPath: '/accounting/crosstab'
      preLoaderRoute: typeof AccountingCrosstabRouteImport
      parentRoute: typeof AccountingRoute
    }
    '/accounting/counterparty-recon': {
      id: '/accounting/counterparty-recon'
      path: '/counterparty-recon'
      fullPath: '/accounting/counterparty-recon'
      preLoaderRoute: typeof AccountingCounterpartyReconRouteImport
      parentRoute: typeof AccountingRoute
    }
    '/accounting/consolidation': {
      id: '/accounting/consolidation'
      path: '/consolidation'
      fullPath: '/accounting/consolidation'
      preLoaderRoute: typeof AccountingConsolidationRouteImport
      parentRoute: typeof AccountingRoute
    }
    '/accounting/close': {
      id: '/accounting/close'
      path: '/close'
      fullPath: '/accounting/close'
      preLoaderRoute: typeof AccountingCloseRouteImport
      parentRoute: typeof AccountingRoute
    }
    '/accounting/budget': {
      id: '/accounting/budget'
      path: '/budget'
      fullPath: '/accounting/budget'
      preLoaderRoute: typeof AccountingBudgetRouteImport
      parentRoute: typeof AccountingRoute
    }
    '/accounting/bank': {
      id: '/accounting/bank'
      path: '/bank'
      fullPath: '/accounting/bank'
      preLoaderRoute: typeof AccountingBankRouteImport
      parentRoute: typeof AccountingRoute
    }
    '/accounting/assets': {
      id: '/accounting/assets'
      path: '/assets'
      fullPath: '/accounting/assets'
      preLoaderRoute: typeof AccountingAssetsRouteImport
      parentRoute: typeof AccountingRoute
    }
    '/accounting/analysis': {
      id: '/accounting/analysis'
      path: '/analysis'
      fullPath: '/accounting/analysis'
      preLoaderRoute: typeof AccountingAnalysisRouteImport
      parentRoute: typeof AccountingRoute
    }
    '/accounting/accounts': {
      id: '/accounting/accounts'
      path: '/accounts'
      fullPath: '/accounting/accounts'
      preLoaderRoute: typeof AccountingAccountsRouteImport
      parentRoute: typeof AccountingRoute
    }
    '/settings/subscription/': {
      id: '/settings/subscription/'
      path: '/'
      fullPath: '/settings/subscription/'
      preLoaderRoute: typeof SettingsSubscriptionIndexRouteImport
      parentRoute: typeof SettingsSubscriptionRoute
    }
    '/settings/plugins/': {
      id: '/settings/plugins/'
      path: '/'
      fullPath: '/settings/plugins/'
      preLoaderRoute: typeof SettingsPluginsIndexRouteImport
      parentRoute: typeof SettingsPluginsRoute
    }
    '/docs/portal/': {
      id: '/docs/portal/'
      path: '/'
      fullPath: '/docs/portal/'
      preLoaderRoute: typeof DocsPortalIndexRouteImport
      parentRoute: typeof DocsPortalRoute
    }
    '/docs/plugins/': {
      id: '/docs/plugins/'
      path: '/'
      fullPath: '/docs/plugins/'
      preLoaderRoute: typeof DocsPluginsIndexRouteImport
      parentRoute: typeof DocsPluginsRoute
    }
    '/docs/phase1/': {
      id: '/docs/phase1/'
      path: '/phase1'
      fullPath: '/docs/phase1/'
      preLoaderRoute: typeof DocsPhase1IndexRouteImport
      parentRoute: typeof DocsRoute
    }
    '/commerce/shipments/': {
      id: '/commerce/shipments/'
      path: '/'
      fullPath: '/commerce/shipments/'
      preLoaderRoute: typeof CommerceShipmentsIndexRouteImport
      parentRoute: typeof CommerceShipmentsRoute
    }
    '/commerce/returns/': {
      id: '/commerce/returns/'
      path: '/'
      fullPath: '/commerce/returns/'
      preLoaderRoute: typeof CommerceReturnsIndexRouteImport
      parentRoute: typeof CommerceReturnsRoute
    }
    '/commerce/quotes/': {
      id: '/commerce/quotes/'
      path: '/'
      fullPath: '/commerce/quotes/'
      preLoaderRoute: typeof CommerceQuotesIndexRouteImport
      parentRoute: typeof CommerceQuotesRoute
    }
    '/commerce/orders/': {
      id: '/commerce/orders/'
      path: '/'
      fullPath: '/commerce/orders/'
      preLoaderRoute: typeof CommerceOrdersIndexRouteImport
      parentRoute: typeof CommerceOrdersRoute
    }
    '/catalog/products/': {
      id: '/catalog/products/'
      path: '/'
      fullPath: '/catalog/products/'
      preLoaderRoute: typeof CatalogProductsIndexRouteImport
      parentRoute: typeof CatalogProductsRoute
    }
    '/admin/workspaces/': {
      id: '/admin/workspaces/'
      path: '/workspaces'
      fullPath: '/admin/workspaces/'
      preLoaderRoute: typeof AdminWorkspacesIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/features/': {
      id: '/admin/features/'
      path: '/'
      fullPath: '/admin/features/'
      preLoaderRoute: typeof AdminFeaturesIndexRouteImport
      parentRoute: typeof AdminFeaturesRoute
    }
    '/admin/eval/': {
      id: '/admin/eval/'
      path: '/'
      fullPath: '/admin/eval/'
      preLoaderRoute: typeof AdminEvalIndexRouteImport
      parentRoute: typeof AdminEvalRoute
    }
    '/accounting/journal/': {
      id: '/accounting/journal/'
      path: '/journal'
      fullPath: '/accounting/journal/'
      preLoaderRoute: typeof AccountingJournalIndexRouteImport
      parentRoute: typeof AccountingRoute
    }
    '/settings/subscription/billing': {
      id: '/settings/subscription/billing'
      path: '/billing'
      fullPath: '/settings/subscription/billing'
      preLoaderRoute: typeof SettingsSubscriptionBillingRouteImport
      parentRoute: typeof SettingsSubscriptionRoute
    }
    '/settings/plugins/marketplace': {
      id: '/settings/plugins/marketplace'
      path: '/marketplace'
      fullPath: '/settings/plugins/marketplace'
      preLoaderRoute: typeof SettingsPluginsMarketplaceRouteImport
      parentRoute: typeof SettingsPluginsRoute
    }
    '/settings/plugins/developer': {
      id: '/settings/plugins/developer'
      path: '/developer'
      fullPath: '/settings/plugins/developer'
      preLoaderRoute: typeof SettingsPluginsDeveloperRouteImport
      parentRoute: typeof SettingsPluginsRoute
    }
    '/settings/plugins/$pluginId': {
      id: '/settings/plugins/$pluginId'
      path: '/$pluginId'
      fullPath: '/settings/plugins/$pluginId'
      preLoaderRoute: typeof SettingsPluginsPluginIdRouteImport
      parentRoute: typeof SettingsPluginsRoute
    }
    '/settings/export-templates/$id': {
      id: '/settings/export-templates/$id'
      path: '/$id'
      fullPath: '/settings/export-templates/$id'
      preLoaderRoute: typeof SettingsExportTemplatesIdRouteImport
      parentRoute: typeof SettingsExportTemplatesRoute
    }
    '/settings/eval-datasets/$id': {
      id: '/settings/eval-datasets/$id'
      path: '/$id'
      fullPath: '/settings/eval-datasets/$id'
      preLoaderRoute: typeof SettingsEvalDatasetsIdRouteImport
      parentRoute: typeof SettingsEvalDatasetsRoute
    }
    '/settings/catalog/synonyms': {
      id: '/settings/catalog/synonyms'
      path: '/synonyms'
      fullPath: '/settings/catalog/synonyms'
      preLoaderRoute: typeof SettingsCatalogSynonymsRouteImport
      parentRoute: typeof SettingsCatalogRoute
    }
    '/settings/catalog/search': {
      id: '/settings/catalog/search'
      path: '/search'
      fullPath: '/settings/catalog/search'
      preLoaderRoute: typeof SettingsCatalogSearchRouteImport
      parentRoute: typeof SettingsCatalogRoute
    }
    '/settings/catalog/migration': {
      id: '/settings/catalog/migration'
      path: '/migration'
      fullPath: '/settings/catalog/migration'
      preLoaderRoute: typeof SettingsCatalogMigrationRouteImport
      parentRoute: typeof SettingsCatalogRoute
    }
    '/settings/catalog/groups': {
      id: '/settings/catalog/groups'
      path: '/groups'
      fullPath: '/settings/catalog/groups'
      preLoaderRoute: typeof SettingsCatalogGroupsRouteImport
      parentRoute: typeof SettingsCatalogRoute
    }
    '/settings/catalog/enrichment': {
      id: '/settings/catalog/enrichment'
      path: '/enrichment'
      fullPath: '/settings/catalog/enrichment'
      preLoaderRoute: typeof SettingsCatalogEnrichmentRouteImport
      parentRoute: typeof SettingsCatalogRoute
    }
    '/settings/catalog/completeness': {
      id: '/settings/catalog/completeness'
      path: '/completeness'
      fullPath: '/settings/catalog/completeness'
      preLoaderRoute: typeof SettingsCatalogCompletenessRouteImport
      parentRoute: typeof SettingsCatalogRoute
    }
    '/portals/$id/search': {
      id: '/portals/$id/search'
      path: '/search'
      fullPath: '/portals/$id/search'
      preLoaderRoute: typeof PortalsIdSearchRouteImport
      parentRoute: typeof PortalsIdRoute
    }
    '/portals/$id/recommendations': {
      id: '/portals/$id/recommendations'
      path: '/recommendations'
      fullPath: '/portals/$id/recommendations'
      preLoaderRoute: typeof PortalsIdRecommendationsRouteImport
      parentRoute: typeof PortalsIdRoute
    }
    '/portals/$id/policies': {
      id: '/portals/$id/policies'
      path: '/policies'
      fullPath: '/portals/$id/policies'
      preLoaderRoute: typeof PortalsIdPoliciesRouteImport
      parentRoute: typeof PortalsIdRoute
    }
    '/portals/$id/overview': {
      id: '/portals/$id/overview'
      path: '/overview'
      fullPath: '/portals/$id/overview'
      preLoaderRoute: typeof PortalsIdOverviewRouteImport
      parentRoute: typeof PortalsIdRoute
    }
    '/portals/$id/keys': {
      id: '/portals/$id/keys'
      path: '/keys'
      fullPath: '/portals/$id/keys'
      preLoaderRoute: typeof PortalsIdKeysRouteImport
      parentRoute: typeof PortalsIdRoute
    }
    '/portals/$id/config': {
      id: '/portals/$id/config'
      path: '/config'
      fullPath: '/portals/$id/config'
      preLoaderRoute: typeof PortalsIdConfigRouteImport
      parentRoute: typeof PortalsIdRoute
    }
    '/portals/$id/build': {
      id: '/portals/$id/build'
      path: '/build'
      fullPath: '/portals/$id/build'
      preLoaderRoute: typeof PortalsIdBuildRouteImport
      parentRoute: typeof PortalsIdRoute
    }
    '/portals/$id/api': {
      id: '/portals/$id/api'
      path: '/api'
      fullPath: '/portals/$id/api'
      preLoaderRoute: typeof PortalsIdApiRouteImport
      parentRoute: typeof PortalsIdRoute
    }
    '/portals/$id/analytics': {
      id: '/portals/$id/analytics'
      path: '/analytics'
      fullPath: '/portals/$id/analytics'
      preLoaderRoute: typeof PortalsIdAnalyticsRouteImport
      parentRoute: typeof PortalsIdRoute
    }
    '/manufacturing/products/$id': {
      id: '/manufacturing/products/$id'
      path: '/products/$id'
      fullPath: '/manufacturing/products/$id'
      preLoaderRoute: typeof ManufacturingProductsIdRouteImport
      parentRoute: typeof ManufacturingRoute
    }
    '/docs/portal/widget': {
      id: '/docs/portal/widget'
      path: '/widget'
      fullPath: '/docs/portal/widget'
      preLoaderRoute: typeof DocsPortalWidgetRouteImport
      parentRoute: typeof DocsPortalRoute
    }
    '/docs/portal/endpoints': {
      id: '/docs/portal/endpoints'
      path: '/endpoints'
      fullPath: '/docs/portal/endpoints'
      preLoaderRoute: typeof DocsPortalEndpointsRouteImport
      parentRoute: typeof DocsPortalRoute
    }
    '/docs/plugins/sdk-reference': {
      id: '/docs/plugins/sdk-reference'
      path: '/sdk-reference'
      fullPath: '/docs/plugins/sdk-reference'
      preLoaderRoute: typeof DocsPluginsSdkReferenceRouteImport
      parentRoute: typeof DocsPluginsRoute
    }
    '/docs/plugins/publishing': {
      id: '/docs/plugins/publishing'
      path: '/publishing'
      fullPath: '/docs/plugins/publishing'
      preLoaderRoute: typeof DocsPluginsPublishingRouteImport
      parentRoute: typeof DocsPluginsRoute
    }
    '/docs/plugins/getting-started': {
      id: '/docs/plugins/getting-started'
      path: '/getting-started'
      fullPath: '/docs/plugins/getting-started'
      preLoaderRoute: typeof DocsPluginsGettingStartedRouteImport
      parentRoute: typeof DocsPluginsRoute
    }
    '/docs/plugins/capabilities': {
      id: '/docs/plugins/capabilities'
      path: '/capabilities'
      fullPath: '/docs/plugins/capabilities'
      preLoaderRoute: typeof DocsPluginsCapabilitiesRouteImport
      parentRoute: typeof DocsPluginsRoute
    }
    '/docs/phase1/sales': {
      id: '/docs/phase1/sales'
      path: '/phase1/sales'
      fullPath: '/docs/phase1/sales'
      preLoaderRoute: typeof DocsPhase1SalesRouteImport
      parentRoute: typeof DocsRoute
    }
    '/docs/phase1/procurement': {
      id: '/docs/phase1/procurement'
      path: '/phase1/procurement'
      fullPath: '/docs/phase1/procurement'
      preLoaderRoute: typeof DocsPhase1ProcurementRouteImport
      parentRoute: typeof DocsRoute
    }
    '/docs/phase1/admin': {
      id: '/docs/phase1/admin'
      path: '/phase1/admin'
      fullPath: '/docs/phase1/admin'
      preLoaderRoute: typeof DocsPhase1AdminRouteImport
      parentRoute: typeof DocsRoute
    }
    '/diagnostics/session/$id': {
      id: '/diagnostics/session/$id'
      path: '/session/$id'
      fullPath: '/diagnostics/session/$id'
      preLoaderRoute: typeof DiagnosticsSessionIdRouteImport
      parentRoute: typeof DiagnosticsRoute
    }
    '/commerce/shipments/$id': {
      id: '/commerce/shipments/$id'
      path: '/$id'
      fullPath: '/commerce/shipments/$id'
      preLoaderRoute: typeof CommerceShipmentsIdRouteImport
      parentRoute: typeof CommerceShipmentsRoute
    }
    '/commerce/returns/$id': {
      id: '/commerce/returns/$id'
      path: '/$id'
      fullPath: '/commerce/returns/$id'
      preLoaderRoute: typeof CommerceReturnsIdRouteImport
      parentRoute: typeof CommerceReturnsRoute
    }
    '/commerce/quotes/new': {
      id: '/commerce/quotes/new'
      path: '/new'
      fullPath: '/commerce/quotes/new'
      preLoaderRoute: typeof CommerceQuotesNewRouteImport
      parentRoute: typeof CommerceQuotesRoute
    }
    '/commerce/quotes/$id': {
      id: '/commerce/quotes/$id'
      path: '/$id'
      fullPath: '/commerce/quotes/$id'
      preLoaderRoute: typeof CommerceQuotesIdRouteImport
      parentRoute: typeof CommerceQuotesRoute
    }
    '/commerce/pricelists/$id': {
      id: '/commerce/pricelists/$id'
      path: '/$id'
      fullPath: '/commerce/pricelists/$id'
      preLoaderRoute: typeof CommercePricelistsIdRouteImport
      parentRoute: typeof CommercePricelistsRoute
    }
    '/commerce/orders/$id': {
      id: '/commerce/orders/$id'
      path: '/$id'
      fullPath: '/commerce/orders/$id'
      preLoaderRoute: typeof CommerceOrdersIdRouteImport
      parentRoute: typeof CommerceOrdersRoute
    }
    '/catalog/products/$id': {
      id: '/catalog/products/$id'
      path: '/$id'
      fullPath: '/catalog/products/$id'
      preLoaderRoute: typeof CatalogProductsIdRouteImport
      parentRoute: typeof CatalogProductsRoute
    }
    '/catalog/import-reviews/$jobId': {
      id: '/catalog/import-reviews/$jobId'
      path: '/import-reviews/$jobId'
      fullPath: '/catalog/import-reviews/$jobId'
      preLoaderRoute: typeof CatalogImportReviewsJobIdRouteImport
      parentRoute: typeof CatalogRoute
    }
    '/assistant/sessions/$id': {
      id: '/assistant/sessions/$id'
      path: '/sessions/$id'
      fullPath: '/assistant/sessions/$id'
      preLoaderRoute: typeof AssistantSessionsIdRouteImport
      parentRoute: typeof AssistantRoute
    }
    '/admin/workspaces/$id': {
      id: '/admin/workspaces/$id'
      path: '/workspaces/$id'
      fullPath: '/admin/workspaces/$id'
      preLoaderRoute: typeof AdminWorkspacesIdRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/invoices/$id': {
      id: '/admin/invoices/$id'
      path: '/invoices/$id'
      fullPath: '/admin/invoices/$id'
      preLoaderRoute: typeof AdminInvoicesIdRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/features/$id': {
      id: '/admin/features/$id'
      path: '/$id'
      fullPath: '/admin/features/$id'
      preLoaderRoute: typeof AdminFeaturesIdRouteImport
      parentRoute: typeof AdminFeaturesRoute
    }
    '/admin/eval/runs': {
      id: '/admin/eval/runs'
      path: '/runs'
      fullPath: '/admin/eval/runs'
      preLoaderRoute: typeof AdminEvalRunsRouteImport
      parentRoute: typeof AdminEvalRoute
    }
    '/admin/eval/datasets': {
      id: '/admin/eval/datasets'
      path: '/datasets'
      fullPath: '/admin/eval/datasets'
      preLoaderRoute: typeof AdminEvalDatasetsRouteImport
      parentRoute: typeof AdminEvalRoute
    }
    '/admin/eval/compare': {
      id: '/admin/eval/compare'
      path: '/compare'
      fullPath: '/admin/eval/compare'
      preLoaderRoute: typeof AdminEvalCompareRouteImport
      parentRoute: typeof AdminEvalRoute
    }
    '/admin/billing/$id': {
      id: '/admin/billing/$id'
      path: '/$id'
      fullPath: '/admin/billing/$id'
      preLoaderRoute: typeof AdminBillingIdRouteImport
      parentRoute: typeof AdminBillingRoute
    }
    '/accounting/journal/new': {
      id: '/accounting/journal/new'
      path: '/journal/new'
      fullPath: '/accounting/journal/new'
      preLoaderRoute: typeof AccountingJournalNewRouteImport
      parentRoute: typeof AccountingRoute
    }
    '/accounting/journal/$id': {
      id: '/accounting/journal/$id'
      path: '/journal/$id'
      fullPath: '/accounting/journal/$id'
      preLoaderRoute: typeof AccountingJournalIdRouteImport
      parentRoute: typeof AccountingRoute
    }
    '/accounting/close/$periodId': {
      id: '/accounting/close/$periodId'
      path: '/$periodId'
      fullPath: '/accounting/close/$periodId'
      preLoaderRoute: typeof AccountingClosePeriodIdRouteImport
      parentRoute: typeof AccountingCloseRoute
    }
    '/accounting/bank/$id': {
      id: '/accounting/bank/$id'
      path: '/$id'
      fullPath: '/accounting/bank/$id'
      preLoaderRoute: typeof AccountingBankIdRouteImport
      parentRoute: typeof AccountingBankRoute
    }
    '/accounting/accounts/$id': {
      id: '/accounting/accounts/$id'
      path: '/$id'
      fullPath: '/accounting/accounts/$id'
      preLoaderRoute: typeof AccountingAccountsIdRouteImport
      parentRoute: typeof AccountingAccountsRoute
    }
    '/admin/eval/runs/$id': {
      id: '/admin/eval/runs/$id'
      path: '/$id'
      fullPath: '/admin/eval/runs/$id'
      preLoaderRoute: typeof AdminEvalRunsIdRouteImport
      parentRoute: typeof AdminEvalRunsRoute
    }
    '/admin/eval/datasets/$id': {
      id: '/admin/eval/datasets/$id'
      path: '/$id'
      fullPath: '/admin/eval/datasets/$id'
      preLoaderRoute: typeof AdminEvalDatasetsIdRouteImport
      parentRoute: typeof AdminEvalDatasetsRoute
    }
  }
}

interface AccountingAccountsRouteChildren {
  AccountingAccountsIdRoute: typeof AccountingAccountsIdRoute
}

const AccountingAccountsRouteChildren: AccountingAccountsRouteChildren = {
  AccountingAccountsIdRoute: AccountingAccountsIdRoute,
}

const AccountingAccountsRouteWithChildren =
  AccountingAccountsRoute._addFileChildren(AccountingAccountsRouteChildren)

interface AccountingBankRouteChildren {
  AccountingBankIdRoute: typeof AccountingBankIdRoute
}

const AccountingBankRouteChildren: AccountingBankRouteChildren = {
  AccountingBankIdRoute: AccountingBankIdRoute,
}

const AccountingBankRouteWithChildren = AccountingBankRoute._addFileChildren(
  AccountingBankRouteChildren,
)

interface AccountingCloseRouteChildren {
  AccountingClosePeriodIdRoute: typeof AccountingClosePeriodIdRoute
}

const AccountingCloseRouteChildren: AccountingCloseRouteChildren = {
  AccountingClosePeriodIdRoute: AccountingClosePeriodIdRoute,
}

const AccountingCloseRouteWithChildren = AccountingCloseRoute._addFileChildren(
  AccountingCloseRouteChildren,
)

interface AccountingRouteChildren {
  AccountingAccountsRoute: typeof AccountingAccountsRouteWithChildren
  AccountingAnalysisRoute: typeof AccountingAnalysisRoute
  AccountingAssetsRoute: typeof AccountingAssetsRoute
  AccountingBankRoute: typeof AccountingBankRouteWithChildren
  AccountingBudgetRoute: typeof AccountingBudgetRoute
  AccountingCloseRoute: typeof AccountingCloseRouteWithChildren
  AccountingConsolidationRoute: typeof AccountingConsolidationRoute
  AccountingCounterpartyReconRoute: typeof AccountingCounterpartyReconRoute
  AccountingCrosstabRoute: typeof AccountingCrosstabRoute
  AccountingOperationsRoute: typeof AccountingOperationsRoute
  AccountingPayablesRoute: typeof AccountingPayablesRoute
  AccountingQualityCheckRoute: typeof AccountingQualityCheckRoute
  AccountingReceivablesRoute: typeof AccountingReceivablesRoute
  AccountingRecurringRoute: typeof AccountingRecurringRoute
  AccountingSchemasRoute: typeof AccountingSchemasRoute
  AccountingStatementsRoute: typeof AccountingStatementsRoute
  AccountingIndexRoute: typeof AccountingIndexRoute
  AccountingJournalIdRoute: typeof AccountingJournalIdRoute
  AccountingJournalNewRoute: typeof AccountingJournalNewRoute
  AccountingJournalIndexRoute: typeof AccountingJournalIndexRoute
}

const AccountingRouteChildren: AccountingRouteChildren = {
  AccountingAccountsRoute: AccountingAccountsRouteWithChildren,
  AccountingAnalysisRoute: AccountingAnalysisRoute,
  AccountingAssetsRoute: AccountingAssetsRoute,
  AccountingBankRoute: AccountingBankRouteWithChildren,
  AccountingBudgetRoute: AccountingBudgetRoute,
  AccountingCloseRoute: AccountingCloseRouteWithChildren,
  AccountingConsolidationRoute: AccountingConsolidationRoute,
  AccountingCounterpartyReconRoute: AccountingCounterpartyReconRoute,
  AccountingCrosstabRoute: AccountingCrosstabRoute,
  AccountingOperationsRoute: AccountingOperationsRoute,
  AccountingPayablesRoute: AccountingPayablesRoute,
  AccountingQualityCheckRoute: AccountingQualityCheckRoute,
  AccountingReceivablesRoute: AccountingReceivablesRoute,
  AccountingRecurringRoute: AccountingRecurringRoute,
  AccountingSchemasRoute: AccountingSchemasRoute,
  AccountingStatementsRoute: AccountingStatementsRoute,
  AccountingIndexRoute: AccountingIndexRoute,
  AccountingJournalIdRoute: AccountingJournalIdRoute,
  AccountingJournalNewRoute: AccountingJournalNewRoute,
  AccountingJournalIndexRoute: AccountingJournalIndexRoute,
}

const AccountingRouteWithChildren = AccountingRoute._addFileChildren(
  AccountingRouteChildren,
)

interface AdminBillingRouteChildren {
  AdminBillingIdRoute: typeof AdminBillingIdRoute
}

const AdminBillingRouteChildren: AdminBillingRouteChildren = {
  AdminBillingIdRoute: AdminBillingIdRoute,
}

const AdminBillingRouteWithChildren = AdminBillingRoute._addFileChildren(
  AdminBillingRouteChildren,
)

interface AdminEvalDatasetsRouteChildren {
  AdminEvalDatasetsIdRoute: typeof AdminEvalDatasetsIdRoute
}

const AdminEvalDatasetsRouteChildren: AdminEvalDatasetsRouteChildren = {
  AdminEvalDatasetsIdRoute: AdminEvalDatasetsIdRoute,
}

const AdminEvalDatasetsRouteWithChildren =
  AdminEvalDatasetsRoute._addFileChildren(AdminEvalDatasetsRouteChildren)

interface AdminEvalRunsRouteChildren {
  AdminEvalRunsIdRoute: typeof AdminEvalRunsIdRoute
}

const AdminEvalRunsRouteChildren: AdminEvalRunsRouteChildren = {
  AdminEvalRunsIdRoute: AdminEvalRunsIdRoute,
}

const AdminEvalRunsRouteWithChildren = AdminEvalRunsRoute._addFileChildren(
  AdminEvalRunsRouteChildren,
)

interface AdminEvalRouteChildren {
  AdminEvalCompareRoute: typeof AdminEvalCompareRoute
  AdminEvalDatasetsRoute: typeof AdminEvalDatasetsRouteWithChildren
  AdminEvalRunsRoute: typeof AdminEvalRunsRouteWithChildren
  AdminEvalIndexRoute: typeof AdminEvalIndexRoute
}

const AdminEvalRouteChildren: AdminEvalRouteChildren = {
  AdminEvalCompareRoute: AdminEvalCompareRoute,
  AdminEvalDatasetsRoute: AdminEvalDatasetsRouteWithChildren,
  AdminEvalRunsRoute: AdminEvalRunsRouteWithChildren,
  AdminEvalIndexRoute: AdminEvalIndexRoute,
}

const AdminEvalRouteWithChildren = AdminEvalRoute._addFileChildren(
  AdminEvalRouteChildren,
)

interface AdminFeaturesRouteChildren {
  AdminFeaturesIdRoute: typeof AdminFeaturesIdRoute
  AdminFeaturesIndexRoute: typeof AdminFeaturesIndexRoute
}

const AdminFeaturesRouteChildren: AdminFeaturesRouteChildren = {
  AdminFeaturesIdRoute: AdminFeaturesIdRoute,
  AdminFeaturesIndexRoute: AdminFeaturesIndexRoute,
}

const AdminFeaturesRouteWithChildren = AdminFeaturesRoute._addFileChildren(
  AdminFeaturesRouteChildren,
)

interface AdminRouteChildren {
  AdminAuditRoute: typeof AdminAuditRoute
  AdminBillingRoute: typeof AdminBillingRouteWithChildren
  AdminDiagramRoute: typeof AdminDiagramRoute
  AdminEvalRoute: typeof AdminEvalRouteWithChildren
  AdminFeaturesRoute: typeof AdminFeaturesRouteWithChildren
  AdminUsersRoute: typeof AdminUsersRoute
  AdminIndexRoute: typeof AdminIndexRoute
  AdminInvoicesIdRoute: typeof AdminInvoicesIdRoute
  AdminWorkspacesIdRoute: typeof AdminWorkspacesIdRoute
  AdminWorkspacesIndexRoute: typeof AdminWorkspacesIndexRoute
}

const AdminRouteChildren: AdminRouteChildren = {
  AdminAuditRoute: AdminAuditRoute,
  AdminBillingRoute: AdminBillingRouteWithChildren,
  AdminDiagramRoute: AdminDiagramRoute,
  AdminEvalRoute: AdminEvalRouteWithChildren,
  AdminFeaturesRoute: AdminFeaturesRouteWithChildren,
  AdminUsersRoute: AdminUsersRoute,
  AdminIndexRoute: AdminIndexRoute,
  AdminInvoicesIdRoute: AdminInvoicesIdRoute,
  AdminWorkspacesIdRoute: AdminWorkspacesIdRoute,
  AdminWorkspacesIndexRoute: AdminWorkspacesIndexRoute,
}

const AdminRouteWithChildren = AdminRoute._addFileChildren(AdminRouteChildren)

interface AdvisorRouteChildren {
  AdvisorIdRoute: typeof AdvisorIdRoute
  AdvisorIndexRoute: typeof AdvisorIndexRoute
}

const AdvisorRouteChildren: AdvisorRouteChildren = {
  AdvisorIdRoute: AdvisorIdRoute,
  AdvisorIndexRoute: AdvisorIndexRoute,
}

const AdvisorRouteWithChildren =
  AdvisorRoute._addFileChildren(AdvisorRouteChildren)

interface AssistantRouteChildren {
  AssistantThreadIdRoute: typeof AssistantThreadIdRoute
  AssistantMemoryRoute: typeof AssistantMemoryRoute
  AssistantIndexRoute: typeof AssistantIndexRoute
  AssistantSessionsIdRoute: typeof AssistantSessionsIdRoute
}

const AssistantRouteChildren: AssistantRouteChildren = {
  AssistantThreadIdRoute: AssistantThreadIdRoute,
  AssistantMemoryRoute: AssistantMemoryRoute,
  AssistantIndexRoute: AssistantIndexRoute,
  AssistantSessionsIdRoute: AssistantSessionsIdRoute,
}

const AssistantRouteWithChildren = AssistantRoute._addFileChildren(
  AssistantRouteChildren,
)

interface BackgroundJobsRouteChildren {
  BackgroundJobsIdRoute: typeof BackgroundJobsIdRoute
  BackgroundJobsIndexRoute: typeof BackgroundJobsIndexRoute
}

const BackgroundJobsRouteChildren: BackgroundJobsRouteChildren = {
  BackgroundJobsIdRoute: BackgroundJobsIdRoute,
  BackgroundJobsIndexRoute: BackgroundJobsIndexRoute,
}

const BackgroundJobsRouteWithChildren = BackgroundJobsRoute._addFileChildren(
  BackgroundJobsRouteChildren,
)

interface CatalogProductsRouteChildren {
  CatalogProductsIdRoute: typeof CatalogProductsIdRoute
  CatalogProductsIndexRoute: typeof CatalogProductsIndexRoute
}

const CatalogProductsRouteChildren: CatalogProductsRouteChildren = {
  CatalogProductsIdRoute: CatalogProductsIdRoute,
  CatalogProductsIndexRoute: CatalogProductsIndexRoute,
}

const CatalogProductsRouteWithChildren = CatalogProductsRoute._addFileChildren(
  CatalogProductsRouteChildren,
)

interface CatalogRouteChildren {
  CatalogCategoriesRoute: typeof CatalogCategoriesRoute
  CatalogProductsRoute: typeof CatalogProductsRouteWithChildren
  CatalogIndexRoute: typeof CatalogIndexRoute
  CatalogImportReviewsJobIdRoute: typeof CatalogImportReviewsJobIdRoute
}

const CatalogRouteChildren: CatalogRouteChildren = {
  CatalogCategoriesRoute: CatalogCategoriesRoute,
  CatalogProductsRoute: CatalogProductsRouteWithChildren,
  CatalogIndexRoute: CatalogIndexRoute,
  CatalogImportReviewsJobIdRoute: CatalogImportReviewsJobIdRoute,
}

const CatalogRouteWithChildren =
  CatalogRoute._addFileChildren(CatalogRouteChildren)

interface CommerceOrdersRouteChildren {
  CommerceOrdersIdRoute: typeof CommerceOrdersIdRoute
  CommerceOrdersIndexRoute: typeof CommerceOrdersIndexRoute
}

const CommerceOrdersRouteChildren: CommerceOrdersRouteChildren = {
  CommerceOrdersIdRoute: CommerceOrdersIdRoute,
  CommerceOrdersIndexRoute: CommerceOrdersIndexRoute,
}

const CommerceOrdersRouteWithChildren = CommerceOrdersRoute._addFileChildren(
  CommerceOrdersRouteChildren,
)

interface CommercePricelistsRouteChildren {
  CommercePricelistsIdRoute: typeof CommercePricelistsIdRoute
}

const CommercePricelistsRouteChildren: CommercePricelistsRouteChildren = {
  CommercePricelistsIdRoute: CommercePricelistsIdRoute,
}

const CommercePricelistsRouteWithChildren =
  CommercePricelistsRoute._addFileChildren(CommercePricelistsRouteChildren)

interface CommerceQuotesRouteChildren {
  CommerceQuotesIdRoute: typeof CommerceQuotesIdRoute
  CommerceQuotesNewRoute: typeof CommerceQuotesNewRoute
  CommerceQuotesIndexRoute: typeof CommerceQuotesIndexRoute
}

const CommerceQuotesRouteChildren: CommerceQuotesRouteChildren = {
  CommerceQuotesIdRoute: CommerceQuotesIdRoute,
  CommerceQuotesNewRoute: CommerceQuotesNewRoute,
  CommerceQuotesIndexRoute: CommerceQuotesIndexRoute,
}

const CommerceQuotesRouteWithChildren = CommerceQuotesRoute._addFileChildren(
  CommerceQuotesRouteChildren,
)

interface CommerceReturnsRouteChildren {
  CommerceReturnsIdRoute: typeof CommerceReturnsIdRoute
  CommerceReturnsIndexRoute: typeof CommerceReturnsIndexRoute
}

const CommerceReturnsRouteChildren: CommerceReturnsRouteChildren = {
  CommerceReturnsIdRoute: CommerceReturnsIdRoute,
  CommerceReturnsIndexRoute: CommerceReturnsIndexRoute,
}

const CommerceReturnsRouteWithChildren = CommerceReturnsRoute._addFileChildren(
  CommerceReturnsRouteChildren,
)

interface CommerceShipmentsRouteChildren {
  CommerceShipmentsIdRoute: typeof CommerceShipmentsIdRoute
  CommerceShipmentsIndexRoute: typeof CommerceShipmentsIndexRoute
}

const CommerceShipmentsRouteChildren: CommerceShipmentsRouteChildren = {
  CommerceShipmentsIdRoute: CommerceShipmentsIdRoute,
  CommerceShipmentsIndexRoute: CommerceShipmentsIndexRoute,
}

const CommerceShipmentsRouteWithChildren =
  CommerceShipmentsRoute._addFileChildren(CommerceShipmentsRouteChildren)

interface CommerceRouteChildren {
  CommerceAnalyticsRoute: typeof CommerceAnalyticsRoute
  CommerceDeliveryRoute: typeof CommerceDeliveryRoute
  CommerceOrdersRoute: typeof CommerceOrdersRouteWithChildren
  CommercePaymentsRoute: typeof CommercePaymentsRoute
  CommercePortalsRoute: typeof CommercePortalsRoute
  CommercePricelistsRoute: typeof CommercePricelistsRouteWithChildren
  CommercePricingRoute: typeof CommercePricingRoute
  CommercePromotionsRoute: typeof CommercePromotionsRoute
  CommerceQuotesRoute: typeof CommerceQuotesRouteWithChildren
  CommerceReturnsRoute: typeof CommerceReturnsRouteWithChildren
  CommerceShipmentsRoute: typeof CommerceShipmentsRouteWithChildren
  CommerceSubscriptionsRoute: typeof CommerceSubscriptionsRoute
  CommerceIndexRoute: typeof CommerceIndexRoute
}

const CommerceRouteChildren: CommerceRouteChildren = {
  CommerceAnalyticsRoute: CommerceAnalyticsRoute,
  CommerceDeliveryRoute: CommerceDeliveryRoute,
  CommerceOrdersRoute: CommerceOrdersRouteWithChildren,
  CommercePaymentsRoute: CommercePaymentsRoute,
  CommercePortalsRoute: CommercePortalsRoute,
  CommercePricelistsRoute: CommercePricelistsRouteWithChildren,
  CommercePricingRoute: CommercePricingRoute,
  CommercePromotionsRoute: CommercePromotionsRoute,
  CommerceQuotesRoute: CommerceQuotesRouteWithChildren,
  CommerceReturnsRoute: CommerceReturnsRouteWithChildren,
  CommerceShipmentsRoute: CommerceShipmentsRouteWithChildren,
  CommerceSubscriptionsRoute: CommerceSubscriptionsRoute,
  CommerceIndexRoute: CommerceIndexRoute,
}

const CommerceRouteWithChildren = CommerceRoute._addFileChildren(
  CommerceRouteChildren,
)

interface DiagnosticsRouteChildren {
  DiagnosticsActivityRoute: typeof DiagnosticsActivityRoute
  DiagnosticsAnalyticsRoute: typeof DiagnosticsAnalyticsRoute
  DiagnosticsDevicesRoute: typeof DiagnosticsDevicesRoute
  DiagnosticsExportsRoute: typeof DiagnosticsExportsRoute
  DiagnosticsLiveRoute: typeof DiagnosticsLiveRoute
  DiagnosticsPoliciesRoute: typeof DiagnosticsPoliciesRoute
  DiagnosticsSessionsRoute: typeof DiagnosticsSessionsRoute
  DiagnosticsStorageRoute: typeof DiagnosticsStorageRoute
  DiagnosticsIndexRoute: typeof DiagnosticsIndexRoute
  DiagnosticsSessionIdRoute: typeof DiagnosticsSessionIdRoute
}

const DiagnosticsRouteChildren: DiagnosticsRouteChildren = {
  DiagnosticsActivityRoute: DiagnosticsActivityRoute,
  DiagnosticsAnalyticsRoute: DiagnosticsAnalyticsRoute,
  DiagnosticsDevicesRoute: DiagnosticsDevicesRoute,
  DiagnosticsExportsRoute: DiagnosticsExportsRoute,
  DiagnosticsLiveRoute: DiagnosticsLiveRoute,
  DiagnosticsPoliciesRoute: DiagnosticsPoliciesRoute,
  DiagnosticsSessionsRoute: DiagnosticsSessionsRoute,
  DiagnosticsStorageRoute: DiagnosticsStorageRoute,
  DiagnosticsIndexRoute: DiagnosticsIndexRoute,
  DiagnosticsSessionIdRoute: DiagnosticsSessionIdRoute,
}

const DiagnosticsRouteWithChildren = DiagnosticsRoute._addFileChildren(
  DiagnosticsRouteChildren,
)

interface DocsPluginsRouteChildren {
  DocsPluginsCapabilitiesRoute: typeof DocsPluginsCapabilitiesRoute
  DocsPluginsGettingStartedRoute: typeof DocsPluginsGettingStartedRoute
  DocsPluginsPublishingRoute: typeof DocsPluginsPublishingRoute
  DocsPluginsSdkReferenceRoute: typeof DocsPluginsSdkReferenceRoute
  DocsPluginsIndexRoute: typeof DocsPluginsIndexRoute
}

const DocsPluginsRouteChildren: DocsPluginsRouteChildren = {
  DocsPluginsCapabilitiesRoute: DocsPluginsCapabilitiesRoute,
  DocsPluginsGettingStartedRoute: DocsPluginsGettingStartedRoute,
  DocsPluginsPublishingRoute: DocsPluginsPublishingRoute,
  DocsPluginsSdkReferenceRoute: DocsPluginsSdkReferenceRoute,
  DocsPluginsIndexRoute: DocsPluginsIndexRoute,
}

const DocsPluginsRouteWithChildren = DocsPluginsRoute._addFileChildren(
  DocsPluginsRouteChildren,
)

interface DocsPortalRouteChildren {
  DocsPortalEndpointsRoute: typeof DocsPortalEndpointsRoute
  DocsPortalWidgetRoute: typeof DocsPortalWidgetRoute
  DocsPortalIndexRoute: typeof DocsPortalIndexRoute
}

const DocsPortalRouteChildren: DocsPortalRouteChildren = {
  DocsPortalEndpointsRoute: DocsPortalEndpointsRoute,
  DocsPortalWidgetRoute: DocsPortalWidgetRoute,
  DocsPortalIndexRoute: DocsPortalIndexRoute,
}

const DocsPortalRouteWithChildren = DocsPortalRoute._addFileChildren(
  DocsPortalRouteChildren,
)

interface DocsRouteChildren {
  DocsPluginsRoute: typeof DocsPluginsRouteWithChildren
  DocsPortalRoute: typeof DocsPortalRouteWithChildren
  DocsIndexRoute: typeof DocsIndexRoute
  DocsPhase1AdminRoute: typeof DocsPhase1AdminRoute
  DocsPhase1ProcurementRoute: typeof DocsPhase1ProcurementRoute
  DocsPhase1SalesRoute: typeof DocsPhase1SalesRoute
  DocsPhase1IndexRoute: typeof DocsPhase1IndexRoute
}

const DocsRouteChildren: DocsRouteChildren = {
  DocsPluginsRoute: DocsPluginsRouteWithChildren,
  DocsPortalRoute: DocsPortalRouteWithChildren,
  DocsIndexRoute: DocsIndexRoute,
  DocsPhase1AdminRoute: DocsPhase1AdminRoute,
  DocsPhase1ProcurementRoute: DocsPhase1ProcurementRoute,
  DocsPhase1SalesRoute: DocsPhase1SalesRoute,
  DocsPhase1IndexRoute: DocsPhase1IndexRoute,
}

const DocsRouteWithChildren = DocsRoute._addFileChildren(DocsRouteChildren)

interface ManufacturingRouteChildren {
  ManufacturingActionsRoute: typeof ManufacturingActionsRoute
  ManufacturingBoardRoute: typeof ManufacturingBoardRoute
  ManufacturingExceptionsRoute: typeof ManufacturingExceptionsRoute
  ManufacturingProductionRoute: typeof ManufacturingProductionRoute
  ManufacturingSopRoute: typeof ManufacturingSopRoute
  ManufacturingIndexRoute: typeof ManufacturingIndexRoute
  ManufacturingProductsIdRoute: typeof ManufacturingProductsIdRoute
}

const ManufacturingRouteChildren: ManufacturingRouteChildren = {
  ManufacturingActionsRoute: ManufacturingActionsRoute,
  ManufacturingBoardRoute: ManufacturingBoardRoute,
  ManufacturingExceptionsRoute: ManufacturingExceptionsRoute,
  ManufacturingProductionRoute: ManufacturingProductionRoute,
  ManufacturingSopRoute: ManufacturingSopRoute,
  ManufacturingIndexRoute: ManufacturingIndexRoute,
  ManufacturingProductsIdRoute: ManufacturingProductsIdRoute,
}

const ManufacturingRouteWithChildren = ManufacturingRoute._addFileChildren(
  ManufacturingRouteChildren,
)

interface PartiesRouteChildren {
  PartiesIdRoute: typeof PartiesIdRoute
  PartiesIndexRoute: typeof PartiesIndexRoute
}

const PartiesRouteChildren: PartiesRouteChildren = {
  PartiesIdRoute: PartiesIdRoute,
  PartiesIndexRoute: PartiesIndexRoute,
}

const PartiesRouteWithChildren =
  PartiesRoute._addFileChildren(PartiesRouteChildren)

interface PortalsIdRouteChildren {
  PortalsIdAnalyticsRoute: typeof PortalsIdAnalyticsRoute
  PortalsIdApiRoute: typeof PortalsIdApiRoute
  PortalsIdBuildRoute: typeof PortalsIdBuildRoute
  PortalsIdConfigRoute: typeof PortalsIdConfigRoute
  PortalsIdKeysRoute: typeof PortalsIdKeysRoute
  PortalsIdOverviewRoute: typeof PortalsIdOverviewRoute
  PortalsIdPoliciesRoute: typeof PortalsIdPoliciesRoute
  PortalsIdRecommendationsRoute: typeof PortalsIdRecommendationsRoute
  PortalsIdSearchRoute: typeof PortalsIdSearchRoute
}

const PortalsIdRouteChildren: PortalsIdRouteChildren = {
  PortalsIdAnalyticsRoute: PortalsIdAnalyticsRoute,
  PortalsIdApiRoute: PortalsIdApiRoute,
  PortalsIdBuildRoute: PortalsIdBuildRoute,
  PortalsIdConfigRoute: PortalsIdConfigRoute,
  PortalsIdKeysRoute: PortalsIdKeysRoute,
  PortalsIdOverviewRoute: PortalsIdOverviewRoute,
  PortalsIdPoliciesRoute: PortalsIdPoliciesRoute,
  PortalsIdRecommendationsRoute: PortalsIdRecommendationsRoute,
  PortalsIdSearchRoute: PortalsIdSearchRoute,
}

const PortalsIdRouteWithChildren = PortalsIdRoute._addFileChildren(
  PortalsIdRouteChildren,
)

interface PortalsRouteChildren {
  PortalsIdRoute: typeof PortalsIdRouteWithChildren
  PortalsIndexRoute: typeof PortalsIndexRoute
}

const PortalsRouteChildren: PortalsRouteChildren = {
  PortalsIdRoute: PortalsIdRouteWithChildren,
  PortalsIndexRoute: PortalsIndexRoute,
}

const PortalsRouteWithChildren =
  PortalsRoute._addFileChildren(PortalsRouteChildren)

interface SettingsCatalogRouteChildren {
  SettingsCatalogCompletenessRoute: typeof SettingsCatalogCompletenessRoute
  SettingsCatalogEnrichmentRoute: typeof SettingsCatalogEnrichmentRoute
  SettingsCatalogGroupsRoute: typeof SettingsCatalogGroupsRoute
  SettingsCatalogMigrationRoute: typeof SettingsCatalogMigrationRoute
  SettingsCatalogSearchRoute: typeof SettingsCatalogSearchRoute
  SettingsCatalogSynonymsRoute: typeof SettingsCatalogSynonymsRoute
}

const SettingsCatalogRouteChildren: SettingsCatalogRouteChildren = {
  SettingsCatalogCompletenessRoute: SettingsCatalogCompletenessRoute,
  SettingsCatalogEnrichmentRoute: SettingsCatalogEnrichmentRoute,
  SettingsCatalogGroupsRoute: SettingsCatalogGroupsRoute,
  SettingsCatalogMigrationRoute: SettingsCatalogMigrationRoute,
  SettingsCatalogSearchRoute: SettingsCatalogSearchRoute,
  SettingsCatalogSynonymsRoute: SettingsCatalogSynonymsRoute,
}

const SettingsCatalogRouteWithChildren = SettingsCatalogRoute._addFileChildren(
  SettingsCatalogRouteChildren,
)

interface SettingsEvalDatasetsRouteChildren {
  SettingsEvalDatasetsIdRoute: typeof SettingsEvalDatasetsIdRoute
}

const SettingsEvalDatasetsRouteChildren: SettingsEvalDatasetsRouteChildren = {
  SettingsEvalDatasetsIdRoute: SettingsEvalDatasetsIdRoute,
}

const SettingsEvalDatasetsRouteWithChildren =
  SettingsEvalDatasetsRoute._addFileChildren(SettingsEvalDatasetsRouteChildren)

interface SettingsExportTemplatesRouteChildren {
  SettingsExportTemplatesIdRoute: typeof SettingsExportTemplatesIdRoute
}

const SettingsExportTemplatesRouteChildren: SettingsExportTemplatesRouteChildren =
  {
    SettingsExportTemplatesIdRoute: SettingsExportTemplatesIdRoute,
  }

const SettingsExportTemplatesRouteWithChildren =
  SettingsExportTemplatesRoute._addFileChildren(
    SettingsExportTemplatesRouteChildren,
  )

interface SettingsPluginsRouteChildren {
  SettingsPluginsPluginIdRoute: typeof SettingsPluginsPluginIdRoute
  SettingsPluginsDeveloperRoute: typeof SettingsPluginsDeveloperRoute
  SettingsPluginsMarketplaceRoute: typeof SettingsPluginsMarketplaceRoute
  SettingsPluginsIndexRoute: typeof SettingsPluginsIndexRoute
}

const SettingsPluginsRouteChildren: SettingsPluginsRouteChildren = {
  SettingsPluginsPluginIdRoute: SettingsPluginsPluginIdRoute,
  SettingsPluginsDeveloperRoute: SettingsPluginsDeveloperRoute,
  SettingsPluginsMarketplaceRoute: SettingsPluginsMarketplaceRoute,
  SettingsPluginsIndexRoute: SettingsPluginsIndexRoute,
}

const SettingsPluginsRouteWithChildren = SettingsPluginsRoute._addFileChildren(
  SettingsPluginsRouteChildren,
)

interface SettingsSubscriptionRouteChildren {
  SettingsSubscriptionBillingRoute: typeof SettingsSubscriptionBillingRoute
  SettingsSubscriptionIndexRoute: typeof SettingsSubscriptionIndexRoute
}

const SettingsSubscriptionRouteChildren: SettingsSubscriptionRouteChildren = {
  SettingsSubscriptionBillingRoute: SettingsSubscriptionBillingRoute,
  SettingsSubscriptionIndexRoute: SettingsSubscriptionIndexRoute,
}

const SettingsSubscriptionRouteWithChildren =
  SettingsSubscriptionRoute._addFileChildren(SettingsSubscriptionRouteChildren)

interface SettingsRouteChildren {
  SettingsAgentProfilesRoute: typeof SettingsAgentProfilesRoute
  SettingsAppearanceRoute: typeof SettingsAppearanceRoute
  SettingsCatalogRoute: typeof SettingsCatalogRouteWithChildren
  SettingsChannelsRoute: typeof SettingsChannelsRoute
  SettingsCodeTemplatesRoute: typeof SettingsCodeTemplatesRoute
  SettingsComplianceRoute: typeof SettingsComplianceRoute
  SettingsDiagramRoute: typeof SettingsDiagramRoute
  SettingsEvalDatasetsRoute: typeof SettingsEvalDatasetsRouteWithChildren
  SettingsExportTemplatesRoute: typeof SettingsExportTemplatesRouteWithChildren
  SettingsGeneralRoute: typeof SettingsGeneralRoute
  SettingsIntegrationsRoute: typeof SettingsIntegrationsRoute
  SettingsKnowledgeRoute: typeof SettingsKnowledgeRoute
  SettingsMembersRoute: typeof SettingsMembersRoute
  SettingsMetalRoute: typeof SettingsMetalRoute
  SettingsNotificationsRoute: typeof SettingsNotificationsRoute
  SettingsOrganizationRoute: typeof SettingsOrganizationRoute
  SettingsPluginsRoute: typeof SettingsPluginsRouteWithChildren
  SettingsProfileRoute: typeof SettingsProfileRoute
  SettingsRolesRoute: typeof SettingsRolesRoute
  SettingsServiceAccountsRoute: typeof SettingsServiceAccountsRoute
  SettingsSubscriptionRoute: typeof SettingsSubscriptionRouteWithChildren
  SettingsSuppliersRoute: typeof SettingsSuppliersRoute
  SettingsTagsRoute: typeof SettingsTagsRoute
  SettingsTeamEmailRoute: typeof SettingsTeamEmailRoute
  SettingsTokensRoute: typeof SettingsTokensRoute
  SettingsWebhooksRoute: typeof SettingsWebhooksRoute
  SettingsWorkItemsRoute: typeof SettingsWorkItemsRoute
  SettingsIndexRoute: typeof SettingsIndexRoute
}

const SettingsRouteChildren: SettingsRouteChildren = {
  SettingsAgentProfilesRoute: SettingsAgentProfilesRoute,
  SettingsAppearanceRoute: SettingsAppearanceRoute,
  SettingsCatalogRoute: SettingsCatalogRouteWithChildren,
  SettingsChannelsRoute: SettingsChannelsRoute,
  SettingsCodeTemplatesRoute: SettingsCodeTemplatesRoute,
  SettingsComplianceRoute: SettingsComplianceRoute,
  SettingsDiagramRoute: SettingsDiagramRoute,
  SettingsEvalDatasetsRoute: SettingsEvalDatasetsRouteWithChildren,
  SettingsExportTemplatesRoute: SettingsExportTemplatesRouteWithChildren,
  SettingsGeneralRoute: SettingsGeneralRoute,
  SettingsIntegrationsRoute: SettingsIntegrationsRoute,
  SettingsKnowledgeRoute: SettingsKnowledgeRoute,
  SettingsMembersRoute: SettingsMembersRoute,
  SettingsMetalRoute: SettingsMetalRoute,
  SettingsNotificationsRoute: SettingsNotificationsRoute,
  SettingsOrganizationRoute: SettingsOrganizationRoute,
  SettingsPluginsRoute: SettingsPluginsRouteWithChildren,
  SettingsProfileRoute: SettingsProfileRoute,
  SettingsRolesRoute: SettingsRolesRoute,
  SettingsServiceAccountsRoute: SettingsServiceAccountsRoute,
  SettingsSubscriptionRoute: SettingsSubscriptionRouteWithChildren,
  SettingsSuppliersRoute: SettingsSuppliersRoute,
  SettingsTagsRoute: SettingsTagsRoute,
  SettingsTeamEmailRoute: SettingsTeamEmailRoute,
  SettingsTokensRoute: SettingsTokensRoute,
  SettingsWebhooksRoute: SettingsWebhooksRoute,
  SettingsWorkItemsRoute: SettingsWorkItemsRoute,
  SettingsIndexRoute: SettingsIndexRoute,
}

const SettingsRouteWithChildren = SettingsRoute._addFileChildren(
  SettingsRouteChildren,
)

interface WorkItemsRouteChildren {
  WorkItemsIdRoute: typeof WorkItemsIdRoute
  WorkItemsIndexRoute: typeof WorkItemsIndexRoute
}

const WorkItemsRouteChildren: WorkItemsRouteChildren = {
  WorkItemsIdRoute: WorkItemsIdRoute,
  WorkItemsIndexRoute: WorkItemsIndexRoute,
}

const WorkItemsRouteWithChildren = WorkItemsRoute._addFileChildren(
  WorkItemsRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AccountingRoute: AccountingRouteWithChildren,
  ActivityRoute: ActivityRoute,
  AdminRoute: AdminRouteWithChildren,
  AdvisorRoute: AdvisorRouteWithChildren,
  AssistantRoute: AssistantRouteWithChildren,
  BackgroundJobsRoute: BackgroundJobsRouteWithChildren,
  CatalogRoute: CatalogRouteWithChildren,
  CommerceRoute: CommerceRouteWithChildren,
  DeviceRoute: DeviceRoute,
  DiagnosticsRoute: DiagnosticsRouteWithChildren,
  DocsRoute: DocsRouteWithChildren,
  LoginRoute: LoginRoute,
  ManufacturingRoute: ManufacturingRouteWithChildren,
  NotificationsRoute: NotificationsRoute,
  OnboardingRoute: OnboardingRoute,
  OrdersRoute: OrdersRoute,
  PartiesRoute: PartiesRouteWithChildren,
  PortalsRoute: PortalsRouteWithChildren,
  PricingRoute: PricingRoute,
  ProductsRoute: ProductsRoute,
  QuotesRoute: QuotesRoute,
  SettingsRoute: SettingsRouteWithChildren,
  WidgetRoute: WidgetRoute,
  WorkItemsRoute: WorkItemsRouteWithChildren,
  AuthCallbackRoute: AuthCallbackRoute,
  AuthMcpCallbackRoute: AuthMcpCallbackRoute,
  InviteTokenRoute: InviteTokenRoute,
  KnowledgeDocIdRoute: KnowledgeDocIdRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
